import { Component, OnInit, NgZone, ChangeDetectorRef, AfterViewInit, ViewChild } from '@angular/core';
import { kezdoUrl } from './kezdo-url';
import { ablakModalIndit } from './ablak-modal';
//import { AuthService } from '@auth0/auth0-angular';
import { Storage } from '@ionic/storage-angular';

import { mergeMap, take } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { Browser } from '@capacitor/browser';
import { App } from '@capacitor/app';
import { callbackUri } from './auth.config';

import { switchMap } from 'rxjs/operators';

import { jsPDF } from "jspdf"
//import { KeycloakService } from "keycloak-angular";
//import { KeycloakProfile } from 'keycloak-js';
import { environment } from "../environments/environment";
import { addIcons } from "ionicons";
import { fejlesztoNev } from "./jogszabalyfigyelo/fejleszto";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { NgSelectConfig } from '@ng-select/ng-select';
import * as CryptoJS from 'crypto-js';
import { DataService } from './data.service';
import { IonModal, LoadingController, Platform } from '@ionic/angular';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { LoadingService } from './loading.interceptor';
import { OAuthService } from 'angular-oauth2-oidc';
import { PushService } from './push.service';
import { Title } from '@angular/platform-browser';
import { modeNev, modeCim, modeFavicon, modeSzinek, valaszthatoModok, NEM_ONALLO_MODOK } from './mode-nevek';
import { ProfilkepService } from './components/profilkep/profilkep.service';
import { KeretService } from './keret.service';
import { BerService } from './ber/ber.service';
import { keretVilagos, szinmodAktiv } from './szinmod';
import { FelhasznaloBeallitasService } from './felhasznalo-beallitas.service';
import { FOKUSZ_KEPES, ModulTema, kijeloltTema, probaBeallit, probaTema, temaNev } from './modul-tema';
import { ervenyesJogkorNezet, jogkorNezetMent, sajatNezetVisszaallit } from './jogkor-nezet-tarolo';

/*
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';*/


/**
 *  A KITÖLTÉSI MÓD NÉLKÜLI IONIC MEZŐK KERETESEK (fill="outline"), egységesen az egész felületen.
 *  Csak a modern (label attribútumos) mezőkre, amelyek NINCSENEK ion-item-ben: a régi, ion-item +
 *  ion-label szerkezetű mezőn a keret kettőzne. A szándékosan más kitöltésű mező (fill="solid")
 *  marad. Egy figyelő tartja fenn, mert a mezők az oldalváltáskor jönnek létre.
 */
function keretesMezok(zona?: { runOutsideAngular<T>(fn: () => T): T }) {
  const MEZOK = 'ion-input:not([fill]), ion-select:not([fill]), ion-textarea:not([fill])';
  //  Címke nélkül (még) nem keretezhető mezők: a [label] kötés később is megjöhet (adatbetöltés
  //  után), ezért a következő körökben ezeket – és csak ezeket – újra megnézzük.
  const varo = new Set<Element>();
  const egy = (el: Element) => {
    if (el.hasAttribute('fill') || el.closest('ion-item')) { varo.delete(el); return; }
    if (!el.hasAttribute('label') && !(el as any).label) { varo.add(el); return; }
    varo.delete(el);
    el.setAttribute('fill', 'outline');
  };
  const allit = (gyoker: ParentNode) => gyoker.querySelectorAll(MEZOK).forEach(egy);
  //  AZ ANGULAR ZÓNÁJÁN KÍVÜL (2026-10-16): a zónán belül a figyelő és a requestAnimationFrame
  //  minden DOM-változás után változásészlelést indított; ha egy sablon minden körben új listát ad
  //  (pl. getter → *ngFor), az újrarajzolás újabb DOM-változás – végtelen kör, a lap nem válaszolt
  //  (a fegyelmi oldal, és mobilon a „pörgő” kezdőképernyő). Az attribútum beállításához nem kell
  //  változásészlelés.
  //  CSAK AZ ÚJ ELEMEKET (2026-10-16): eddig minden DOM-változás után az egész dokumentumot
  //  átnézte, és az ion-item-beli (kimaradó) mezőket minden körben újra – nagy oldalon (napló,
  //  osztályzó rács) folyamatos többletmunka. Most csak a hozzáadott részfákat nézi.
  const indit = () => {
    try {
      allit(document);
      let uj: Element[] = [];
      new MutationObserver((valtozasok) => {
        const indul = !uj.length;
        for (const v of valtozasok) v.addedNodes.forEach((n) => { if (n.nodeType === 1) uj.push(n as Element); });
        if (!indul || !uj.length) return;
        requestAnimationFrame(() => {
          const lista = uj; uj = [];
          for (const el of varo) if (el.isConnected) egy(el); else varo.delete(el);
          for (const el of lista) {
            if (!el.isConnected) continue;
            if (el.matches(MEZOK)) egy(el);
            allit(el);
          }
        });
      }).observe(document.body, { childList: true, subtree: true });
    } catch { /* régi böngésző: a mezők a sablon szerinti kinézettel maradnak */ }
  };
  if (zona) zona.runOutsideAngular(indit); else indit();
}

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})

export class AppComponent implements OnInit, AfterViewInit {
  private readonly logoutPendingKey = 'ny_logout_pending';
  /** Egyszeri jelölő: lejárt munkamenet után indított automatikus újrabelépés. */
  private readonly ujraBelepesKulcs = 'ny_reauth_attempt';
  /**
   * Indulási hiba a felhasználónak. Üres képernyő helyett MONDJUK MEG, mi
   * történt – a néma fehér lapból a felhasználó nem tud mit kezdeni.
   */
  bootHiba = '';

  /*  FRISSÍTÉS ELÉRHETŐ – csak adminisztrátornak.
   *
   *  A jelzésnek jól látható helyen kell lennie: ha csak egy admin-almenüben állna,
   *  sosem derülne ki, hogy hetek óta van újabb verzió. A lekérdezés admin-védett, a
   *  többieknél 403-mal elszáll – azt csendben elnyeljük, nekik nem is szól. */
  frissitesElerheto: { legujabb: string; jelenlegi: string | null } | null = null;

  /*  A MENÜ JELVÉNYE. Külön a sávtól, mert a kettő mást csinál: a sáv figyelmeztet
   *  egyszer, és el lehet tenni a szem elől; a jelvény viszont NEM tüntethető el, mert
   *  az az emlékeztető. Aki reggel elrejtette a sávot, annak délután is látnia kell,
   *  hogy még mindig van tennivaló. */
  ujVerzio: string | null = null;

  /*  A MENÜ ALJÁN A TÉNYLEGESEN FUTÓ VERZIÓ áll, nem egy build-idejű állandó.
   *
   *  Eddig az `environment.version` látszott (v2.0.5), amit senki nem frissített:
   *  hónapokig ugyanazt mutatta, függetlenül attól, mi futott. Most a kiszolgálótól
   *  kérdezzük meg – ugyanabból a forrásból, amit a frissítés-ellenőrzés is használ,
   *  tehát a kiírt szám és az „elérhető verzió" ugyanazt jelenti.
   *
   *  Ha a kiszolgáló nem tudja (a telepítés nem adta át a képfájl címkéjét), azt
   *  KIÍRJUK, nem találunk ki helyette számot: a hamis verzió rosszabb, mint a
   *  bevallott hiány – az alapján senki nem tudná eldönteni, kell-e frissíteni. */
  futoVerzio: string | null = null;
  verzioIsmeretlen = false;

  private async verzioBetoltese() {
    try {
      const r: any = await firstValueFrom(this.http.get('/api/version'));
      this.futoVerzio = r?.verzio || null;
      this.verzioIsmeretlen = !this.futoVerzio;
    } catch (e) {
      this.verzioIsmeretlen = true;
    }
    this.cdr.detectChanges();
  }

  /*  A JELZÉS LEKÉRÉSE.
   *
   *  A könnyű `/jelzes` végpontot kérdezzük, nem a teljes `/allapot`-ot. Két okból:
   *
   *    - az `/allapot` a registryt is megkérdezi, a migrációkat is végignézi, és a
   *      futás-előzményt is lehozza – a menü jelvényéhez ebből EGY bit kell;
   *    - az `/allapot` nem-adminnál 403-mal szállt el, tehát MINDEN belépés hibát írt a
   *      naplóba egy olyan kérésért, aminek náluk nincs is értelme. A `/jelzes` szépen
   *      annyit felel, hogy „nem vagy admin".
   *
   *  Magát a registryt a kiszolgáló nézi meg, naponta kétszer, magától. */
  /** Mikor kérdeztük utoljára – a navigációnkénti újraellenőrzés ritkításához. */
  private frissitesUtoljara = 0;

  /**
   *  ÚJRAELLENŐRZÉS OLDALVÁLTÁSKOR, ritkítva.
   *
   *  A jelzés eddig EGYSZER, induláskor dőlt el, és onnantól ott maradt. Aki
   *  adminként lépett be, majd intézményt vagy alrendszert váltott – vagy más nevében
   *  lépett be –, annál a jelvény a RÉGI, admin helyzetet mutatta akkor is, amikor
   *  már nem volt admin. Ezért minden oldalváltáskor újrakérdezzük, de legfeljebb
   *  ötpercenként: a jelzés kényelmi funkció, nem kell percenként hívni a registryt.
   */
  private frissitesUjraEllenorzes() {
    const most = Date.now();
    if (most - this.frissitesUtoljara < 5 * 60 * 1000) return;
    this.frissitesUtoljara = most;
    this.frissitesEllenorzes();
  }

  private async frissitesEllenorzes() {
    /*  ELŐBB TÖRLÜNK. A korábbi válasz nem maradhat érvényben: ha közben elveszett
     *  az admin jog (szerepkör- vagy intézményváltás, belépés más nevében), a régi
     *  érték továbbra is jelezne – pedig ez a jelzés KIZÁRÓLAG adminisztrátornak szól. */
    this.ujVerzio = null;
    this.frissitesElerheto = null;
    this.frissitesUtoljara = Date.now();
    try {
      const intez = String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
      // A modul adminja is frissíthet (backend/frissites.js), ezért a modult is elküldjük.
      const mod = String(this.currentMode || '');
      const r: any = await firstValueFrom(this.http.get(
        `/api/frissites/jelzes?intezmeny=${encodeURIComponent(intez)}${mod ? `&mode=${encodeURIComponent(mod)}` : ''}`));
      if (!r?.admin || !r?.van_ujitas || !r?.legujabb) return;

      // A menü jelvénye mindig szól – ez az emlékeztető.
      this.ujVerzio = r.legujabb;
      // A sáv viszont naponta eltehető a szem elől.
      let elrejtve = false;
      try {
        elrejtve = localStorage.getItem('frissites-sav-elrejtve')
          === new Date().toISOString().slice(0, 10);
      } catch (e) { /* privát mód: akkor mutatjuk */ }
      if (!elrejtve) this.frissitesElerheto = { legujabb: r.legujabb, jelenlegi: r.jelenlegi };
      this.cdr.detectChanges();
    } catch (e) { /* nincs kapcsolat – nem jelzünk */ }
  }

  /** BÉR oldalsáv: az Átalányadós csak átalányadózó ügyfélnél (ber-menu.ts). A cégautós pontok 2026-10-18 óta a
   *  Gépjármű modulban vannak – a régi menüsorok (2026-10-18-gepjarmu-3-ber-menu.sql: letiltva) nem látszanak. */
  berMenuLathato(url: string): boolean {
    if (url === '/ber/atalany') return !!this.ber.aktiv.atalanyado;
    if (String(url || '').startsWith('/ber/cegauto')) return false;
    return true;
  }

  /** Erre a menüpontra kerül az „új verzió" jelvény. */
  frissitesMenu(url: string): boolean {
    return url === '/admin' || url === '/admin/frissites';
  }

  /*  Összecsukott csoportnál a FEJLÉCEN kell jeleznünk, különben a jelvény pont ott
   *  rejtőzne el, ahol emlékeztetnie kellene. */
  frissitesCsoport(p: any): boolean {
    return (p?.submenu || []).some((s: any) => this.frissitesMenu(String(s?.url || '')));
  }

  frissitesreUgras() {
    try { this.router.navigateByUrl('/admin/frissites'); } catch (e) { /* ignore */ }
  }

  frissitesSavElrejt(esemeny: Event) {
    esemeny.stopPropagation();
    try { localStorage.setItem('frissites-sav-elrejtve', new Date().toISOString().slice(0, 10)); } catch (e) { /* ignore */ }
    this.frissitesElerheto = null;
  }
  /** Olvasatlan üzenetek száma – a bal menü „Üzenetek" pontjának jelvénye. */
  olvasatlanUzenet = 0;
  private olvasatlanIdozito: any = null;

  /**
   *  Az olvasatlan-szám frissítése. Percenként fut, és minden oldalváltáskor is:
   *  így a jelvény akkor is eltűnik, amikor a felhasználó elolvasta az üzeneteket,
   *  és akkor is megjelenik, ha közben érkezett új.
   */
  async olvasatlanFrissit() {
    // A hibajegyek jelvénye ugyanezen az ütemen frissül – külön kérés, külön hibakezelés,
    // hogy az üzenet-jelvény hibája ne vigye magával.
    this.hibajegyFrissit();
    this.adatjavitasFrissit();
    try {
      const intezmeny = (await this.data.getFromStorage('sajatIntezmeny'))?.intezmenyId;
      const mod = await this.data.getFromStorage('loginmode');
      const meta: any = await this.data.getFromStorage('userMetadata');
      const felhasznalo = mod === 'tanulo'
        ? String(meta?.oktazon || meta?.username || '')
        : String(meta?.adid || meta?.username || '');
      if (!intezmeny || !felhasznalo) return;
      const r: any = await firstValueFrom(this.http.get(
        `/api/uzenet/olvasatlan/${intezmeny}?felhasznalo=${encodeURIComponent(felhasznalo)}`));
      this.olvasatlanUzenet = Number(r?.olvasatlan || 0);
      if (!this.olvasatlanIdozito) {
        this.olvasatlanIdozito = setInterval(() => this.olvasatlanFrissit(), 60000);
      }
    } catch (e) { /* a jelvény nem viheti magával a menüt */ }
  }

  /** A menüpont mutasson-e jelvényt (az üzenetek oldal bármelyik útvonalán). */
  uzenetMenu(url: string): boolean {
    return url === '/message' || url === '/uzenetek';
  }

  /**
   *  HIBAJELENTÉS – a saját jegyek olvasatlan változásainak száma (állapotváltás, válasz a
   *  hibakezelőből). Ugyanaz a mechanizmus, mint az üzeneteké: az `olvasatlanFrissit`
   *  percenkénti ütemén és minden oldalváltáskor frissül, egyetlen olcsó összegzéssel.
   *
   *  Ugyanez a kérés mondja meg azt is, hogy a funkció be van-e kapcsolva ennek a
   *  belépőnek (`aktiv`): ebből lesz a menüsor `onactive = hibajegyAktiv` kapcsolója. A
   *  tanulónak a kiszolgáló 403-at ad – nála nem is kérdezünk.
   */
  olvasatlanHibajegy = 0;

  private async hibajegyParameterek(): Promise<string | null> {
    const intezmeny = String((await this.data.getFromStorage('sajatIntezmeny'))?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    const mod = await this.data.getFromStorage('loginmode');
    if (!intezmeny || mod === 'tanulo' || !this.currentMode) return null;
    const szerep = mod === 'gondviselo' ? 'gondviselo' : 'munkatars';
    return `intezmeny=${encodeURIComponent(intezmeny)}&szerep=${szerep}`
      + `&alrendszer=${encodeURIComponent(String(this.currentMode))}`;
  }

  async hibajegyFrissit(): Promise<boolean> {
    try {
      const p = await this.hibajegyParameterek();
      if (!p) { this.olvasatlanHibajegy = 0; return false; }
      const r: any = await firstValueFrom(this.http.get(`/api/hibajegy/allapot?${p}`));
      this.olvasatlanHibajegy = r?.aktiv ? Number(r?.olvasatlan || 0) : 0;
      return !!r?.aktiv;
    } catch (e) {
      this.olvasatlanHibajegy = 0;
      return false;
    }
  }

  /** A menü építése előtt: a „Hibajelentés" pont csak bekapcsolt funkciónál látszik. */
  async computeHibajegyFlag(): Promise<void> {
    try {
      await this.data.setStorage('hibajegyAktiv', await this.hibajegyFrissit());
    } catch (e) { /* a menü nem akadhat el rajta */ }
  }

  hibajegyMenu(url: string): boolean {
    return url === '/hibajegy';
  }

  /**
   *  ADATHIBA JELZÉSE – adminnak az át nem nézett bejelentések száma a menüpont mellett
   *  (a kollégák bejelentéseit a rendszer azonnal végrehajtja; ezt az admin utólag nézi át).
   *  Nem adminnak a kiszolgáló 0-t ad, tanulónál és gondviselőnél nem is kérdezünk.
   */
  atnezetlenAdatjavitas = 0;

  async adatjavitasFrissit(): Promise<void> {
    try {
      const intezmeny = String((await this.data.getFromStorage('sajatIntezmeny'))?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
      const mod = await this.data.getFromStorage('loginmode');
      if (!intezmeny || mod === 'tanulo' || mod === 'gondviselo' || this.currentMode !== 'SULINFORM') { this.atnezetlenAdatjavitas = 0; return; }
      const r: any = await firstValueFrom(this.http.get(`/api/adatjavitas/allapot?intezmeny=${encodeURIComponent(intezmeny)}`));
      this.atnezetlenAdatjavitas = r?.admin ? Number(r?.atnezetlen || 0) : 0;
    } catch (e) { this.atnezetlenAdatjavitas = 0; }
  }

  adatjavitasMenu(url: string): boolean {
    return url === '/adatjavitas';
  }

  /**
   *  Nincs beállítva a KRÉTA-hozzáférés → a menüpont pirosan jelez.
   *
   *  A szinkron a tanár nevében lép be a KRÉTA-ba, ezért aki nem adta meg a saját
   *  belépését, annak az órái nem íródnak be – ez viszont csak akkor derülne ki,
   *  amikor már baj van. A piros háttér ezt előre kimondja.
   */
  kretaHianyzik = false;

  async kretaAllapotFrissit() {
    try {
      const mod = await this.data.getFromStorage('loginmode');
      if (mod !== 'dolgozo') { this.kretaHianyzik = false; return; }
      const intezmeny = (await this.data.getFromStorage('sajatIntezmeny'))?.intezmenyId;
      const meta: any = await this.data.getFromStorage('userMetadata');
      const allomany = String(meta?.adid || meta?.username || '');
      if (!intezmeny || !allomany) return;
      const r: any = await firstValueFrom(this.http.get(
        `/api/naplo-kreta-naploz/sajat/${encodeURIComponent(allomany)}/${intezmeny}`));
      // Jelszó nélkül a felhasználónév önmagában nem elég a belépéshez.
      this.kretaHianyzik = !(r?.beallitva && r?.van_jelszo);
      await this.data.setStorage('kretaBeallitva', !this.kretaHianyzik);
    } catch (e) { /* a jelzés nem viheti magával a menüt */ }
  }

  /** A KRÉTA-menüpont útvonala – ehhez tesszük a piros hátteret. */
  kretaMenu(url: string): boolean { return url === '/kreta-sajat'; }

  public appPages = [
    /*
    { title: 'Home', url: '/home', icon: 'mail' },
    { title: 'Outbox', url: '/folder/outbox', icon: 'paper-plane' },
    { title: 'Favorites', url: '/folder/favorites', icon: 'heart' },
    { title: 'Archived', url: '/folder/archived', icon: 'archive' },
    { title: 'Trash', url: '/folder/trash', icon: 'trash' },
    { title: 'Spam', url: '/folder/spam', icon: 'warning' },
  */
  ];
  public labels = []; //['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
  public user$ //: KeycloakProfile | null = null;//this.auth.isAuthenticated$.pipe(switchMap(() => this.auth.user$));


  userMetadata;
  sajatIntezmeny
  public isLoggedIn = false;
  darkMode =
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches;
  auth0Users
  selectedUser
  migracio = false
  intezmenyek = []
  loginmode = "dolgozo"

  /*  BELÉPÉS MÁS NEVÉBEN (admin nézetváltás).
   *
   *  A jelölő SZÁNDÉKOSAN nem az alkalmazás tárolójában van, hanem külön: a
   *  nézetváltáskor a teljes tárolót ki kell üríteni (különben a saját menü és
   *  törzsadat maradna bent), és ha a jelölő is ott lenne, épp az veszne el, amiről
   *  az egész szól. Így a takarítás után is tudjuk, kinek a nevében indulunk.
   *
   *  A kiszolgáló felé TOVÁBBRA IS az admin tokenje megy: ez a NÉZETET váltja át,
   *  nem a jogosultságot. Erre a fejlécsáv is figyelmeztet.
   */
  static readonly IMPERSONALAS_KULCS = 'cronom_impersonalas';
  impersonalas: any = null;

  private impersonalasOlvas(): any {
    try {
      const nyers = localStorage.getItem(AppComponent.IMPERSONALAS_KULCS);
      return nyers ? JSON.parse(nyers) : null;
    } catch (e) { return null; }
  }

  /* ══════════════════════════════════════════════════════════════════════════
   *  JOGKÖR-NÉZET  ·  „nézzük meg pedagógusként"
   *
   *  A más nevében belépéstől KÜLÖNBÖZIK: ott másvalaki nézetét látjuk, itt a
   *  SAJÁTUNKAT, kevesebb joggal. És itt a kiszolgáló is tudja: a menet-azonosító
   *  fejlécként megy, a jogosultság-modul pedig abból az EGY jogkörből építi a
   *  láncot. Ezért mondható, hogy a jogkör „teljeskörűen" az lesz.
   *
   *  Csak olyan jogkörre lehet váltani, amivel a felhasználó valóban rendelkezik —
   *  a váltás szűkít, sosem bővít. A visszaváltás semmilyen jogot nem kér, mert épp
   *  akkor kell, amikor a felhasználó már nem admin.
   * ═══════════════════════════════════════════════════════════════════════ */
  static readonly JOGKOR_NEZET_KULCS = 'cronom_jogkor_nezet';
  jogkorNezet: any = null;
  /** Amire válthat (a valódi jogkörei). Egy elemnél nincs mit felkínálni. */
  jogkorNezetValaszthato: any[] = [];

  /*  Csak az AKTUÁLIS kilét nézete számít: más nevében belépve az admin saját nézete
   *  félre van téve (jogkor-nezet-tarolo.ts) – különben a tanuló nevében is admin
   *  menü és admin jogkör-választó látszott. */
  private jogkorNezetOlvas(): any {
    return ervenyesJogkorNezet();
  }

  /** A választó adatforrása – a lenyíló `cim`/`jogkor` mezőt vár. */
  private jogkorCimke(j: string): string {
    const NEV: any = {
      admin: 'Adminisztrátor', rendszergazda: 'Rendszergazda', pedagogus: 'Pedagógus',
      igazgato: 'Igazgató', igh: 'Igazgatóhelyettes', ig: 'Igazgató',
      of: 'Osztályfőnök', ofhely: 'Osztályfőnök-helyettes', iskolatitkar: 'Iskolatitkár',
    };
    return NEV[j] || (j ? j.charAt(0).toUpperCase() + j.slice(1) : j);
  }

  async jogkorNezetBetolt() {
    this.jogkorNezet = this.jogkorNezetOlvas();
    const iid = this.sajatIntezmeny?.intezmenyId;
    if (!iid) { this.jogkorNezetValaszthato = []; return; }
    try {
      const v: any = await firstValueFrom(this.http.get(
        `/api/jogkor-nezet/allapot/${iid}?alrendszer=${encodeURIComponent(this.currentMode || 'SULINFORM')}`));
      /*  Más nevében a kiszolgáló a CÉL kilétével válaszol (a fejlécben a menet megy):
       *  a lista a cél valódi jogköreiből áll – tanulónál/szülőnél üres, így a választó
       *  el sem jelenik. */
      this.jogkorNezetValaszthato = (v?.valaszthato || [])
        .map((j: string) => ({ jogkor: j, cim: this.jogkorCimke(j) }));
      /*  A kiszolgáló a mérce: ha ott már nincs nyitott menet (pl. lejárt vagy más
       *  gépen zárták le), a helyi jelölést is eldobjuk – különben a felület
       *  szűkítést mutatna, ami már nem él. */
      if (!v?.aktiv && this.jogkorNezet) {
        try { localStorage.removeItem(AppComponent.JOGKOR_NEZET_KULCS); } catch (e) { /* ignore */ }
        this.jogkorNezet = null;
      }
    } catch (e) {
      this.jogkorNezetValaszthato = [];
    }
  }

  jogkorNezetNev(): string {
    return this.jogkorCimke(this.jogkorNezet?.jogkor || '');
  }

  async jogkorNezetValaszt(esemeny: any) {
    /*  A kereshető lenyíló TÖMBÖT küld (`[{ jogkor, cim }]`), mint a tanév-választónál –
     *  enélkül az üres jogkörrel csendben kiléptünk, és a váltás sosem indult el. */
    const valasztott = Array.isArray(esemeny) ? esemeny[0] : esemeny;
    const jogkor = valasztott?.jogkor || valasztott?.value?.jogkor
      || (typeof valasztott?.value === 'string' ? valasztott.value : '') || '';
    if (!jogkor || jogkor === this.jogkorNezet?.jogkor) return;
    try {
      const v: any = await firstValueFrom(this.http.post('/api/jogkor-nezet/kezd', {
        intezmeny: this.sajatIntezmeny?.intezmenyId,
        alrendszer: this.currentMode || 'SULINFORM',
        jogkor,
      }));
      if (!v?.menet) throw new Error('nincs menet');
      //  A jelölő megjegyzi, melyik kilétben (saját / más nevében) készült.
      jogkorNezetMent(v.menet, v.jogkor);
      /*  Teljes újratöltés: a menü, a jogosultság-mátrix és a képernyők állapota is
       *  a jogkörből él – féloldalasan frissíteni több hibát okozna, mint amennyit
       *  a gyorsaság ér. */
      window.location.href = '/';
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A jogkör-nézetre váltás nem sikerült.', 'error');
    }
  }

  /** Vissza a teljes jogkörbe. Ez soha nem kérhet admin jogot – lásd a modul fejlécét. */
  async jogkorNezetVege() {
    const menet = this.jogkorNezet?.menet || null;
    try {
      await firstValueFrom(this.http.post('/api/jogkor-nezet/vege', { menet }));
    } catch (e) { /* a naplózás elmaradhat, a visszalépést az nem akadályozhatja */ }
    try { localStorage.removeItem(AppComponent.JOGKOR_NEZET_KULCS); } catch (e) { /* ignore */ }
    this.jogkorNezet = null;
    window.location.href = '/';
  }

  /** Kilépés a más nevében nézetből – vissza a saját fiókba. */
  async impersonalasVege() {
    const menet = this.impersonalas?.menet || null;
    /*  JOGKÖR-NÉZET VISSZAÁLLÍTÁSA. Ha a cél nevében nyílt jogkör-nézet (admin célnál
     *  lehetséges), azt MÉG most zárjuk le – a kérés ilyenkor a cél kilétével megy, és
     *  a menet az övé; a más-nevében-menet lezárása után már nem érnénk el. Utána a
     *  belépéskor félretett SAJÁT nézet visszakerül: az admin oda jut vissza, ahonnan
     *  elindult (jogkor-nezet-tarolo.ts). */
    const celNezet = this.jogkorNezetOlvas();
    if (celNezet?.menet && celNezet?.impersonalas) {
      try {
        await firstValueFrom(this.http.post('/api/jogkor-nezet/vege', { menet: celNezet.menet }));
      } catch (e) { /* a visszalépést nem akadályozhatja */ }
    }
    sajatNezetVisszaallit(this.impersonalas?.sajat_jogkor_nezet || null);
    this.jogkorNezet = null;
    try {
      await firstValueFrom(this.http.post('/api/impersonalas/vege', { menet }));
    } catch (e) { /* a naplózás elmaradhat, a visszalépést az nem akadályozhatja */ }
    try { localStorage.removeItem(AppComponent.IMPERSONALAS_KULCS); } catch (e) { /* ignore */ }
    this.impersonalas = null;
    await this.resetApplicationSession();
    window.location.href = '/';
  }
  tanev
  tanevadatok
  // A bal menü tanév-választójában éppen kiválasztott tanév (= munkatanév). Nem azonos az
  // intézmény aktuális tanévével: azt csak a tanévváltó „Megnyitás" gombja állítja.
  valasztottTanev: number | null = null
  // Az alrendszer-kód 6 helyen áll be (bootstrap, váltás, fixedMode, storage…). Setterként a
  // böngészőfül címe/ikonja MINDIG együtt mozog vele – nem lehet elfelejteni egy ágon.
  private _currentMode: any = null;
  get currentMode(): any { return this._currentMode; }
  set currentMode(v: any) { this._currentMode = v; this.fulCimEsIkon(); }
  modes = []
  modeNev = modeNev   // alrendszer kódjának felhasználóbarát neve (fallback: a kód)

  // A böngészőfül címét és ikonját az AKTUÁLIS alrendszerhez igazítja (korábban mindig
  // „Cronomit Sulinform” volt, csak a Billiárd írta felül). Több nyitott fülnél így látszik,
  // melyik modul melyik. A <link rel=icon> hiányozhat (natív build) → akkor létrehozzuk.
  fulCimEsIkon(): void {
    try {
      this.title.setTitle(modeCim(this.currentMode));
      let l = document.querySelector<HTMLLinkElement>('link[rel*="icon"]');
      if (!l) { l = document.createElement('link'); l.rel = 'icon'; document.head.appendChild(l); }
      l.href = modeFavicon(this.currentMode);
    } catch (_) { /* a fül-dísz sose törhet el semmit */ }
  }
  // Több-app matrix: ha ez a build EGY alrendszerre fixált (SULINFORM/NAPLO/BER/CAESAR), akkor az app CSAK
  // azt nyitja, az alrendszer-váltó eltűnik, és csak a fixedMode-ot támogató intézmények látszanak.
  get fixedMode(): string { return String((environment as any).fixedMode || '').toUpperCase(); }

  nincsFixModeIntezmeny = false;   // igaz, ha fixedMode-os appban a usernek nincs ilyen alrendszerű intézménye
  // Egy feladatellátás (intézmény-adat) támogatja-e az adott alrendszert (a mode[] tartalmazza-e).
  // A mode lehet nyers JSON-string (f.mode) vagy már tömb – mindkettőt kezeli.
  intezmenyTamogatModot(d: any, mode: string): boolean {
    try { const m = typeof d?.mode === 'string' ? JSON.parse(d.mode) : d?.mode; return Array.isArray(m) && m.includes(mode); }
    catch { return false; }
  }
  menu = []
  kivceg
  // PDF-motor (LibreOffice) első indításkori beszerzésének toast-állapota (jobb alsó sarok).
  pdfMotor: any = { show: false, allapot: '', uzenet: '', szazalek: 0, hiba: false, kesz: false };
  private pdfMotorLatottAktiv = false;
  @ViewChild("almenumodal") almenumodal: IonModal;
  //isNative = Capacitor.isNativePlatform();

  constructor(
    public storage: Storage,
    //public auth: AuthService,
    private ngZone: NgZone,
    //public keycloak: KeycloakService,
    private http: HttpClient,
    private config: NgSelectConfig,
    private ref: ChangeDetectorRef,
    private data: DataService,
    public ber: BerService,
    private loadingCtrl: LoadingController,
    private router: Router,
    private cdr: ChangeDetectorRef,
    public platform: Platform,
    public auth: AuthService,
    private oauth: OAuthService,
    private push: PushService,
    private title: Title,
    public loading: LoadingService,
    private keret: KeretService,
    private profilkep: ProfilkepService,
    private felhBeallitas: FelhasznaloBeallitasService,
  ) {
    //  Asztali programban a felugró ablakok (modálok) valódi, külön ablakban nyílnak – ablak-modal.ts.
    ablakModalIndit();
    //  MINDEN MEZŐ KERETES (2026-10-16, a user: „mindenhol, ahol nem ez a körbe szegett mező van,
    //  javítsd ki”): az ng-select a Material-téma keretes megjelenésével (global.scss igazítja az
    //  Ionic outline-mezőkhöz), a kitöltési mód nélküli Ionic mezők pedig fill="outline"-t kapnak.
    //  Itt, a legelején – a választó a létrejöttekor olvassa a beállítást.
    this.config.appearance = 'outline';
    keretesMezok(this.ngZone);
    //  A Beállításokban választott téma azonnal érvényes (a menü, a keret, a body-osztályok).
    this.felhBeallitas.valtozas.subscribe(() => { this.temaProbaTar = null; this.ref.detectChanges(); });
    /*  A Könyvelés (NAPLO) és a Bérszámfejtés (BER) asztali nézetben bal sáv nélkül dolgozik:
     *  a profil, az intézmény- és a modulváltás ott a fejléc lenyílójában van
     *  (components/profil-menu). Ugyanezeket a műveleteket kapja – nem másolatot. */
    this.keret.regisztral({
      avatarUrl: () => this.getUserProfilePictureUrl(),
      avatarHiba: (ev) => this.useGeneratedAvatar(ev),
      logoUrl: () => this.sajatIntezmeny?.intezmenyKep || 'assets/default-intezmeny.svg',
      logoHiba: (ev) => this.useDefaultIntezmenyKep(ev),
      nev: () => [this.userMetadata?.viselt_vez, this.userMetadata?.viselt_ker].filter(Boolean).join(' '),
      intezmenyNev: () => this.sajatIntezmeny?.intezmenyName || '',
      intezmenyId: () => String(this.sajatIntezmeny?.intezmenyId || ''),
      intezmenyek: () => this.intezmenyek || [],
      modok: () => this.modes || [],
      aktualisMod: () => this.currentMode,
      fixedMode: () => this.fixedMode,
      verzio: () => this.futoVerzio || '',
      intezmenyValt: (bejegyzes) => this.selectChangedIntezmeny([bejegyzes]),
      modValt: (mod, celUrl) => this.selectChangedUzemmod([mod], celUrl),
      kilepes: () => this.logout(),
      tema: () => this.aktivTema(),
      kijeloltTema: () => kijeloltTema(this.currentMode, this.sajatIntezmeny?.mode_tema),
      temaValaszthato: () => this.temaAdmin && FOKUSZ_KEPES.has(String(this.currentMode || '')),
      temaProba: (t) => this.temaProba(t),
      temaMent: (t) => this.temaMent(t),
    });
    addIcons({
      'c-1': './assets/numbers/number-circle-one-thin-svgrepo-com.svg',
      'c-2': './assets/numbers/number-circle-two-thin-svgrepo-com.svg',
      'c-3': './assets/numbers/number-circle-three-thin-svgrepo-com.svg',
      'c-4': './assets/numbers/number-circle-four-thin-svgrepo-com.svg',
      'c-5': './assets/numbers/number-circle-five-thin-svgrepo-com.svg',
      // A jogszabályfigyelő mérlege – a bal sáv „-outline”/„-sharp” végződéssel kéri az ikont.
      'jogszabalyfigyelo': './assets/icon/jogszabalyfigyelo.svg',
      'jogszabalyfigyelo-outline': './assets/icon/jogszabalyfigyelo.svg',
      'jogszabalyfigyelo-sharp': './assets/icon/jogszabalyfigyelo.svg',
    });

    // A jegy megnyitása olvasottá teszi – a jelvény ne a következő percben tűnjön el.
    window.addEventListener('hibajegy-olvasva', () => this.hibajegyFrissit());
    window.addEventListener('adatjavitas-atnezve', () => this.adatjavitasFrissit());

    //  Közvetlenül admin-címre nyitva se villanjon fel a bal sáv (az első NavigationEnd előtt).
    this.adminNezet = /^\/admin(\/|\?|$)/.test(window.location.pathname || '');
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.syncBilliardKivceg(event.urlAfterRedirects || event.url);
        /*  A hibabejelentéshez: melyik képernyőről jött a felhasználó. A bejelentés
         *  oldala maga nem számít – onnan nézve a „honnan" az utolsó MÁS képernyő. */
        const ut = String(event.urlAfterRedirects || event.url || '');
        //  Az admin a bal sáv nélkül nyílik; a vissza gombja oda visz, ahonnan belépett.
        this.adminNezet = ut === '/admin' || ut.startsWith('/admin/') || ut.startsWith('/admin?');
        if (ut && !this.adminNezet) {
          try { sessionStorage.setItem('admin-elotti', ut.slice(0, 300)); } catch { /* ignore */ }
        }
        if (ut && !ut.startsWith('/hibajegy')) {
          try { sessionStorage.setItem('hibajegy-honnan', ut.slice(0, 300)); } catch { /* ignore */ }
        }
        // Oldalváltáskor is frissítjük az olvasatlan-számot: az üzenetek oldalról
        // kilépve a jelvény azonnal eltűnjön, ne csak a következő percben.
        this.olvasatlanFrissit();
        // A KRÉTA-jelzés is: mentés után azonnal tűnjön el a piros háttér.
        this.kretaAllapotFrissit();
        // A frissítés-jelzés is: intézmény- vagy szerepkörváltás után ne a RÉGI
        // helyzet látsszon (lásd `frissitesEllenorzes`).
        this.frissitesUjraEllenorzes();
      }
    });

    //  ASZTALI töltő-fátyol a route-váltás / lusta modulbetöltés fehér villanására (weben nem fut).
    if (this.asztaliMod) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) this.fatyolMutat();
        else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) this.fatyolRejt();
      });
    }
  }

  async syncBilliardKivceg(currentUrl: string = "") {
    const url = currentUrl || this.router.url || window.location.pathname || "";
    const match = url.match(/\/(?:b\/)?(kontir|kapocs)\/([^/?#]+)/i);

    if (!match || !match[2]) {
      if (this.currentMode == "BILLIARD") {
        this.kivceg = await this.data.getFromStorage("kivceg");
        this.ref.detectChanges();
      }
      return;
    }

    const adoszam = decodeURIComponent(match[2]);
    this.http
      .get('/api/ugyfel?ugyfel=' + adoszam)
      .subscribe({
        next: async (response: any) => {
          if (response && response[0]) {
            this.kivceg = response[0];
            await this.data.setStorage("kivceg", response[0]);
            this.ref.detectChanges();
          }
        },
        error: async () => {
          this.kivceg = await this.data.getFromStorage("kivceg");
          this.ref.detectChanges();
        },
      });
  }

  getUserProfilePictureUrl(): string {
    const configuredPicture = this.user$?.attributes?.picture || this.user$?.picture;
    return configuredPicture || this.getMicrosoftProfilePictureUrl() || this.getGeneratedAvatarUrl();
  }

  getMicrosoftProfileIdentifier(): string {
    const candidates = [
      this.user$?.email,
      this.user$?.preferred_username,
      this.user$?.username,
      this.userMetadata?.email,
      this.userMetadata?.mail,
      this.userMetadata?.email_cim,
    ];

    return String(candidates.find((value) => String(value || "").includes("@")) || "").trim();
  }

  /*  A saját MS-profilkép TOKENNEL, blobként jön (profilkep.service.ts). Korábban a fejléc egy
   *  sima `<img src="/api/microsoft/profile-photo/…">`-t kapott, ami nem visz belépési jegyet –
   *  a 2.3.140-es kapu óta így sosem jött le, mindig a generált avatar látszott. */
  private sajatKepUrl = "";
  private sajatKepIntezmeny = "";

  getMicrosoftProfilePictureUrl(): string {
    // MS Graph profilfotó csak intézményi dolgozóknak: a szülők (gondviselő) emailje
    // nincs az iskola MS tenantjában, így minden szülői avatar feleslegesen a Graph
    // API-t hívná, ami mindig elhasal és floodolja a backendet (más kérések is elhalnak).
    if (this.loginmode !== 'dolgozo') return "";
    const intezmeny = String(this.sajatIntezmeny?.intezmenyId || "").trim();
    if (intezmeny && intezmeny !== this.sajatKepIntezmeny) {
      this.sajatKepIntezmeny = intezmeny;
      this.sajatKepUrl = "";
      this.profilkep.urit();
      this.profilkep.kep('sajat', '').then((url) => {
        if (this.sajatKepIntezmeny !== intezmeny) return;
        this.sajatKepUrl = url || "";
        if (url) this.ref.detectChanges();
      });
    }
    return this.sajatKepUrl;
  }

  getGeneratedAvatarUrl(): string {
    const metadataName = [
      this.userMetadata?.viselt_vez,
      this.userMetadata?.viselt_ker,
    ].filter(Boolean).join(" ").trim();

    const tokenName = String(this.user$?.name || "").trim();
    const tokenPartsName = [
      this.user$?.family_name,
      this.user$?.given_name,
    ].filter(Boolean).join(" ").trim();
    const username = String(this.user$?.preferred_username || this.user$?.username || "").trim();
    const name = metadataName || tokenName || tokenPartsName || username || "Sulinform";

    return `${environment.avatars}/api/?name=${encodeURIComponent(name)}&rounded=true&size=512&background=random`;
  }

  useGeneratedAvatar(event: Event): void {
    const image = event.target as HTMLImageElement;
    if (!image) return;

    const microsoftProfilePictureUrl = this.getMicrosoftProfilePictureUrl();
    if (microsoftProfilePictureUrl && image.dataset.microsoftAvatarFallbackApplied !== "1") {
      image.dataset.microsoftAvatarFallbackApplied = "1";
      image.src = microsoftProfilePictureUrl;
      return;
    }

    // Külső generált avatar (online) – ha még nem próbáltuk.
    if (image.dataset.avatarFallbackApplied !== "1") {
      image.dataset.avatarFallbackApplied = "1";
      image.src = this.getGeneratedAvatarUrl();
      return;
    }

    // Végső, beépített helyi alapkép – offline (standalone NAS) telepítésen is működik,
    // amikor a külső avatar-szolgáltatás nem érhető el.
    if (image.dataset.localAvatarApplied !== "1") {
      image.dataset.localAvatarApplied = "1";
      image.src = "assets/default-user.svg";
    }
  }

  // Az intézményi kép betöltése meghiúsult (nincs feltöltött logó vagy offline a forrás) →
  // beépített alapértelmezett intézmény-ikon.
  useDefaultIntezmenyKep(event: Event): void {
    const image = event.target as HTMLImageElement;
    if (!image || image.dataset.intezmenyFallbackApplied === "1") return;
    image.dataset.intezmenyFallbackApplied = "1";
    image.src = "assets/default-intezmeny.svg";
  }

  async ngSelectConfig() {
    this.config.notFoundText = 'Nincs találat';
  }
  pushKonfig() {
    this.push.init();
    /*PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // Show some error
      }
    });

    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration',
      (token: Token) => {
        alert('Push registration success, token: ' + token.value);
      }
    );

    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError',
      (error: any) => {
        alert('Error on registration: ' + JSON.stringify(error));
      }
    );

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        alert('Push received: ' + JSON.stringify(notification));
      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        alert('Push action performed: ' + JSON.stringify(notification));
      }
    );*/
  }

  osszekapcsol(nincs = 1) {
    if (nincs == 0) this.selectedUser = 0
    this.http
      .post(
        '/api/connect/' + this.userMetadata.adid + '/' + this.selectedUser,
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: async (response) => {
          this.userMetadata["auth0id"] = this.selectedUser
          await this.data.setStorage("userMetadata", this.userMetadata)
          //this.data.setStorage("userMetadata", JSON.stringify(this.userMetadata))
          window.location.reload()
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }
  /** Egyszeri menü-frissítés jelzője (a refreshMenuFromApi újra setMenu-t hív). */
  private menuFrissitve = false;
  private menuFutas = 0;

  /**
   *  Az intézmény ALRENDSZER-LISTÁJA és a felhasználó JOGKÖREI is a tárolt adatból jönnek,
   *  ezért egy újonnan bekapcsolt modul (pl. IKTATGATO), illetve egy frissen kiosztott
   *  jogkör csak újbóli belépés után jelent volna meg. Induláskor egyszer frissítjük őket
   *  a szerverről.
   *
   *  A jogkör azért kritikus, mert a `getJogkor()` a `sajatIntezmeny.jogkor[<mód>]` kulcsot
   *  olvassa: ha az adott módhoz nincs bejegyzés, `null`-t ad, és a `refreshMenuFromApi()`
   *  el sem indítja a lekérést → a bal menü ÜRES marad, hiába van minden sor a DB-ben.
   */
  /* ── MODULONKÉNTI TÉMA (modul-tema.ts) ─────────────────────────────────────────────────────
   *  Klasszikus = bal sáv; Fókusz = bal sáv nélkül, a modul saját fejlécével (asztali nézetben a
   *  split-pane ki van kapcsolva, a bal sáv csak mobilon nyílik). Az admin jelöli ki modulonként;
   *  a modul adminja a böngészőjében ki is próbálhatja a másikat. */
  temaAdmin = false;
  private temaProbaTar: { kulcs: string; ertek: ModulTema | null } | null = null;

  aktivTema(): ModulTema {
    const mod = String(this.currentMode || '');
    if (!FOKUSZ_KEPES.has(mod)) return 'klasszikus';
    const fe = String(this.sajatIntezmeny?.intezmenyId || '');
    const kulcs = fe + '|' + mod;
    //  Sorrend: a felhasználó saját választása (Beállítások) > a régi, böngészős kipróbálás > az
    //  admin által kijelölt alapértelmezés.
    const sajat = this.felhBeallitas.tema(mod);
    if (sajat) return sajat;
    if (this.temaProbaTar?.kulcs !== kulcs) this.temaProbaTar = { kulcs, ertek: probaTema(fe, mod) };
    return this.temaProbaTar.ertek || kijeloltTema(mod, this.sajatIntezmeny?.mode_tema);
  }

  /*  A téma osztálya a <body>-n van (tema-fokusz / tema-klasszikus), nem csak a tartalmon: a
   *  modulok stílusa innen választ arculatot (:host-context), és így a body-portálba kerülő
   *  modálok, popoverek és riasztások is a téma szerint jelennek meg. */
  private temaOsztaly: boolean | null = null;
  private sulinformFokuszOsztaly: boolean | null = null;
  get fokusz(): boolean {
    const f = this.aktivTema() === 'fokusz';
    if (f !== this.temaOsztaly) {
      this.temaOsztaly = f;
      document.body.classList.toggle('tema-fokusz', f);
      document.body.classList.toggle('tema-klasszikus', !f);
    }
    //  A SULINFORM oldalai nem egy modul-keretben élnek, ezért a Fókusz-arculatuk egy body-szintű
    //  réteg (global.scss › body.sulinform-fokusz) – csak a SULINFORM-ban, a többi modult nem érinti.
    const sf = f && this.currentMode === 'SULINFORM';
    if (sf !== this.sulinformFokuszOsztaly) {
      this.sulinformFokuszOsztaly = sf;
      document.body.classList.toggle('sulinform-fokusz', sf);
      //  Világos/sötét csak itt (szinmod.ts) – Klasszikusban és más modulban mindig világos.
      szinmodAktiv(sf);
    }
    return f;
  }

  /** A SULINFORM Fókuszában a menü és a fejléc világos-e (szinmod.ts) – a menü komponensei ehhez igazodnak. */
  get keretVilagos(): boolean { return keretVilagos(); }

  /** Az admin felületen vagyunk-e (ott nincs bal sáv – lásd menuRejtve). */
  adminNezet = false;

  /*  ASZTALI TÖLTŐ-FÁTYOL. Az asztali (Electron) programban a route-váltás és a lusta (lazy)
   *  modulbetöltés alatt rövid fehér villanás látszik – ettől „webes" a program. A fátyol a téma
   *  színével takarja ezt. CSAK asztali módban (window.CRONOM_ASZTALI) – weben SOHA nem jelenik meg.
   *  Minden navigációs VÉGÁLLAPOTNÁL eltűnik, és egy időzítő is biztosítja, hogy ne akadjon be. */
  readonly asztaliMod = !!(window as any).CRONOM_ASZTALI;
  asztaliFatyol = false;
  private fatyolTimer: any = null;
  private fatyolMutat() {
    if (!this.asztaliMod) return;
    this.asztaliFatyol = true;
    clearTimeout(this.fatyolTimer);
    //  Végső biztosíték: ha valami elnyelné a navigációs végeseményt, a fátyol magától eltűnik.
    this.fatyolTimer = setTimeout(() => { this.asztaliFatyol = false; try { this.cdr.detectChanges(); } catch { /* ignore */ } }, 8000);
  }
  private fatyolRejt() {
    clearTimeout(this.fatyolTimer); this.fatyolTimer = null;
    this.asztaliFatyol = false;
  }

  /** A bal sáv ki van-e kapcsolva: Fókusz témájú modulban és az adminban. A SULINFORM Fókuszában
   *  marad (2026-10-16, a user: „ott kell, de csak itt”) – ott a felső sáv csak kiegészít. */
  get menuRejtve(): boolean {
    return (this.fokusz && this.currentMode !== 'SULINFORM') || this.adminNezet;
  }

  /*  A RÉGI, BÖNGÉSZŐS KIPRÓBÁLÁS ÁTVÉTELE. A téma már a felhasználó saját beállítása (Beállítások);
   *  aki korábban kipróbált egy témát, annak az most is látszik – ezt egyszer átvesszük a saját
   *  beállításába (ha ott még nincs választás), és a próbát töröljük, hogy a Beállítások azt
   *  mutassa, ami ténylegesen érvényes. */
  private probaAtvesz() {
    const fe = String(this.sajatIntezmeny?.intezmenyId || '');
    const mod = String(this.currentMode || '');
    if (!fe || !mod) return;
    const p = probaTema(fe, mod);
    if (!p) return;
    if (!this.felhBeallitas.tema(mod)) this.felhBeallitas.ment({ tema: { [mod]: p } }).catch(() => { /* helyben él */ });
    probaBeallit(fe, mod, null);
    this.temaProbaTar = null;
  }

  private temaProba(t: ModulTema | null) {
    const fe = String(this.sajatIntezmeny?.intezmenyId || '');
    if (!fe || !this.currentMode) return;
    probaBeallit(fe, this.currentMode, t);
    this.temaProbaTar = null;
    this.ref.detectChanges();
  }

  private async temaMent(t: ModulTema) {
    const fe = String(this.sajatIntezmeny?.intezmenyId || '');
    const mod = String(this.currentMode || '');
    if (!fe || !mod) return;
    try {
      const r: any = await firstValueFrom(this.http.put('/api/modul-tema/' + fe, { mode: mod, tema: t }));
      this.sajatIntezmeny.mode_tema = JSON.stringify(r?.tema || {});
      await this.data.setStorage('sajatIntezmeny', this.sajatIntezmeny);
      probaBeallit(fe, mod, null);
      this.temaProbaTar = null;
      this.data.sendToast(`A(z) ${modeNev(mod)} témája mostantól mindenkinek: ${temaNev(t)}.`, 'success');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A téma mentése nem sikerült.', 'error');
    }
    this.ref.detectChanges();
  }

  /** A kijelölt téma és az admin-jog a kiszolgálóról – indulásonként egyszer (a tárolt adat
   *  közben érvényes, így nincs villanás; más admin módosítása a következő indulással ér ide). */
  private async temaFrissit() {
    const fe = String(this.sajatIntezmeny?.intezmenyId || '');
    const mod = String(this.currentMode || '');
    if (!fe || !FOKUSZ_KEPES.has(mod)) { this.temaAdmin = false; return; }
    try {
      const r: any = await firstValueFrom(this.http.get('/api/modul-tema/' + fe, { params: { mode: mod } }));
      this.temaAdmin = !!r?.admin;
      const uj = JSON.stringify(r?.tema || {});
      if (uj !== (this.sajatIntezmeny.mode_tema || '{}')) {
        this.sajatIntezmeny.mode_tema = uj;
        await this.data.setStorage('sajatIntezmeny', this.sajatIntezmeny);
      }
      this.ref.detectChanges();
    } catch { this.temaAdmin = false; }
  }

  private modokFrissitve = false;

  private async modokFrissit() {
    if (this.modokFrissitve) return;
    this.modokFrissitve = true;
    const username = this.getCurrentUsername(this.user$);
    const intezmenyId = this.sajatIntezmeny?.intezmenyId;
    if (!username || !intezmenyId) return;
    try {
      const valasz: any = await firstValueFrom(this.http.get('/api/user/' + username));
      const sor = Array.isArray(valasz) ? valasz[0] : valasz;
      let adatok = sor?.intezmenyadatok;
      if (typeof adatok === 'string') { try { adatok = JSON.parse(adatok); } catch { adatok = null; } }
      const sajat = (adatok || []).find((i: any) => i?.intezmenyId === intezmenyId);
      if (!sajat) return;

      let valtozott = false;

      const modok = Array.isArray(sajat.mode) ? sajat.mode
        : (typeof sajat.mode === 'string' ? JSON.parse(sajat.mode) : null);
      if (modok) {
        this.sajatIntezmeny.mode = modok;
        this.modes = valaszthatoModok(modok.map((d: string) => ({ name: d, cim: modeNev(d) })));
        valtozott = true;
      }

      const jogkorok = this.parseJogkor(sajat.jogkor ?? sor?.jogkor);
      if (jogkorok) {
        this.sajatIntezmeny.jogkor = jogkorok;
        valtozott = true;
      }

      if (!valtozott) return;
      await this.data.setStorage('sajatIntezmeny', this.sajatIntezmeny);
      this.ref.detectChanges();

      /*  A modullista a kiszolgálón a JOGOK szerint szűrt (alrendszer-jog.js): csak az az
       *  alrendszer marad benne, amihez van joga. Ha a TÁROLT aktuális mód már nincs a listán
       *  (elvették a jogát, vagy korábban egy jog nélküli modulra váltott), átállunk a
       *  kiszolgáló által adott kezdő alrendszerre – különben egy üres menüjű modulban ragadna. */
      if (!this.fixedMode && Array.isArray(modok) && modok.length
          && this.currentMode && !modok.includes(this.currentMode)) {
        const uj = modok.includes(sajat.mainmode) ? sajat.mainmode : modok[0];
        this.currentMode = uj;
        this.sajatIntezmeny.mainmode = uj;
        await this.data.setStorage('sajatIntezmeny', this.sajatIntezmeny);
        await this.data.setStorage('currentMode', uj);
        try { this.router.navigateByUrl('/valaszto'); } catch { /* nem kritikus */ }
        window.location.reload();
      }
    } catch (e) {
      // A tárolt adat marad érvényben – az alrendszer-váltó és a menü enélkül is működik.
    }
  }

  async setMenu(userMetadata = null) {
    let u //= await this.auth.user$.pipe(take(1)).toPromise();
    console.log(this.isLoggedIn);
    if (this.isLoggedIn) {
      /*  A menü egy HELYI listába épül, és csak a legutolsó hívás írja ki. A setMenu több
       *  helyről indul (belépés, tárolt adat, szerverfrissítés), és közben többször vár –
       *  ha kettő átfedte egymást, mindkettő ugyanahhoz a (közben kiürített) listához
       *  fűzött, és első belépés után kétszer jelent meg a menü. */
      const futas = ++this.menuFutas;
      const lapok: any[] = [];
      /*this.auth.idTokenClaims$.subscribe((idTokenClaims) => {
        // Extract the user_metadata claim from the ID token
        this.userMetadata = idTokenClaims['https://claims.vszc/user_metadata'];
        //console.log(idTokenClaims['https://claims.vszc/user_metadata']);
      });*/
      if (userMetadata) this.userMetadata = userMetadata; //window.location.reload()
      console.log(this.user$)
      console.log(this.userMetadata)

      // Fixált alrendszernél (több-app matrix) csak a fixedMode-ot támogató intézmények látszanak a váltóban.
      this.intezmenyek = (this.userMetadata.intezmenyadatok || [])
        .filter(d => !this.fixedMode || this.intezmenyTamogatModot(d, this.fixedMode))
        .sort((a, b) => (a.intezmenyName > b.intezmenyName) ? 1 : ((b.intezmenyName > a.intezmenyName) ? -1 : 0))


      lapok.push(
        //{ title: 'Főoldal', url: '/home', icon: 'home' },
        //{ title: 'Profil', external: true, url: environment.keycloak + '/realms/master/account/', icon: 'person-circle', disabled: false },
        ///{ title: 'Faliújság', external:false,url: '/faliujsag', icon: 'newspaper', disabled: false },
        ///{ title: 'Étkezés', external:false,url: '/etkezes', icon: 'restaurant' },
        //{ title: 'Eszköz', external:false,url: '/eszkoz', icon: 'desktop' },
        //{ title: 'Tankönyv', external:false,url: '/tankonyv', icon: 'book' },
        //{ title: 'Szerződés', external:false,url: '/szerzodes', icon: 'document-attach' },
        ///{ title: 'Nyilvántartás', external:false,url: '/nyilvantarto', icon: 'archive' },
        /*{
          title: 'Riportok',
          external:false,
          url: '/munkatarsak',
          icon: 'list',
        },*/
        ///{ title: 'Üzenet', external:false,url: '/message', icon: 'mail', disabled: false },
        //{ title: 'Kérvény', external:false,url: '/kerveny', icon: 'create', disabled: false },
        ///{ title: 'Órarend',external:false, url: '/orarend', icon: 'calendar', disabled: false },
        /*{ title: 'Tantárgyfelosztás',external:false, url: '/ttf', icon: 'calendar', disabled: false, submenu:[
          {title: 'Tantárgyak',external:false, url: '/tantargyak', icon: 'caret-forward', disabled: false}
        ] },*/
        //{ title: 'Helyettesítés',external:false, url: '/helyettesites', icon: 'git-compare', disabled: false },
        //{ title: 'Teremcsere',external:false, url: '/teremcsere', icon: 'code-working', disabled: false },
        //{ title: 'Értekezlet',external:false, url: '/ertekezlet', icon: 'call', disabled: false },
        //{ title: 'Levél', external:false,url: '/level', icon: 'mail' },
        //{ title: 'Bérjegyzék', external:false,url: '/berjegyzek', icon: 'wallet' },
        //{ title: 'Számla', external:false,url: '/szerzodes', icon: 'document' },
        ///{ title: 'Licenc',external:false, url: '/license', icon: 'ribbon', disabled: false },
        //{ title: 'Admin',external:false, url: '/settings', icon: 'cog', disabled: false },
        ///{ title: 'Changelog',external:false, url: '/changelog', icon: 'swap-vertical' },
        ///{ title: 'Hibajegyek', external:true, url: 'https://support.cronomit.hu/spaces/cronomit-group/2ff8f4da-6529-4249-a02c-52e53931e978', icon: 'bug', disabled: false },
      );

      // PROFIL (2026-11-02): a belső, csak olvasható profiloldal (profil/, backend/sajat-profil.js) –
      // a saját adatok, a profilkép, szülőnek a gyermekei. Korábban a Keycloak fiókoldalára mutatott,
      // `disabled: true`-val (kiszürkítve). A MIRA-nak saját Profil pontja van, ezért ott nem kell
      // egy második „Profil" ugyanabban a menüben.
      // (A FITNESS is itt állt, amíg alrendszer volt – az azóta külön program.)
      if (this.currentMode == "MIRA") { }
      else lapok.push({ title: 'Profil', external: false, url: '/profil', icon: 'person-circle', disabled: false },)

      // Osztályfőnök menü láthatóság: az 'isOf' kapcsoló admin vagy tényleges osztályfőnök esetén igaz
      await this.computeOfFlag();
      // Hibajelentés menüpont: csak ha a funkció be van kapcsolva ennek a belépőnek ('hibajegyAktiv').
      await this.computeHibajegyFlag();

      let menu = await this.data.getFromStorage("menu")
      if (!Array.isArray(menu)) menu = [];
      if (this.currentMode === "WEBSHOP") {
        const webshopMenu = [
          { id: -9001, title: 'Webshop oldalak', external: false, url: '/webshop-admin', icon: 'color-wand', disabled: false, sorrend: 10 },
          { id: -9002, title: 'Termékek és kategóriák', external: false, url: '/webshop-admin/catalog', icon: 'storefront', disabled: false, sorrend: 20 },
        ];
        for (const item of webshopMenu) {
          if (!menu.some((menuItem) => menuItem.url === item.url)) {
            menu.push(item);
          }
        }
        menu = menu.sort((a, b) => Number(a.sorrend || 0) - Number(b.sorrend || 0));
      }
      // Fejlesztői, nem publikus pont minden modulban: Jogszabályfigyelő. A lista csak a
      // megjelenítést dönti el – az oldalt és az adatot a kiszolgáló is a fejlesztőhöz köti.
      if (fejlesztoNev(this.getCurrentUsername(this.user$)) && !menu.some((m) => m.url === '/jogszabalyfigyelo')) {
        menu.push({ id: -9101, title: 'Jogszabályfigyelő', external: false, url: '/jogszabalyfigyelo', icon: 'jogszabalyfigyelo', disabled: false, sorrend: 99999 });
      }
      // A FITNESS MENÜ-KIEGÉSZÍTŐ KIKERÜLT. A fitness külön program lett (saját
      // szerver, saját felület, saját menü) – a keretrendszer nem tölthet be
      // menüpontot egy alkalmazáshoz, amit nem ő szolgál ki. Ami itt állt:
      // a Profil és a Segítség pótlása, ha a DB-menüből hiányzott, plusz a
      // `/devcenter` sor kiszűrése. Mindhárom a különvált program dolga.
      //
      // A `menu` táblában maradt FITNESS sorok takarítását a
      // `backend/scripts/fitness-menu-kivezetes.sql` végzi el.
      /*  A KÖNYVELÉSNEK (NAPLO) SAJÁT FŐMENÜJE VAN a modul fejlécében (Törzsadatok, Könyvelés,
       *  Naplók, …, lásd naplo/naplo-menu.ts) – a bal oldali sáv ott csak a kerethez kell (profil,
       *  intézmény- és modulváltás). A jogokat a főmenü ugyanúgy az access-listából veszi. */
      if (this.currentMode === 'NAPLO') menu = [];
      const loginmode = await this.data.getFromStorage("loginmode");
      const jogkor = await this.data.getJogkor();
      /*  A BÉRLET/KOMPENZÁCIÓ MENÜPONT INNEN KIKERÜLT.
       *
       *  Korábban itt tettük hozzá, ha valaki dolgozóként lépett be. Ez ugyanaz a hiba
       *  volt, mint a tanulói menünél és a tantárgyfelosztásnál: a menüpont NEM
       *  látszott a Jogosultságok képernyőn, tehát nem lehetett elvenni, nem lehetett
       *  másnak megadni, és a menü sorrendjébe sem illeszkedett.
       *
       *  Mostantól a `menu` és az `access` táblából jön, mint minden más. Az elbírálói
       *  fület pedig a kiszolgáló engedélyezi (Adminisztrátori jogosultságok →
       *  „Bérlet / kompenzáció – elbírálás"), nem egy kódba írt jogkörlista.
       */
      /*  TANULÓ: a saját adatait a szülői képernyők mutatják (a gyermeklista ő maga).
       *
       *  ITT KORÁBBAN EGY BEDRÓTOZOTT LISTA VOLT, és a menüt LESZŰKÍTETTE rá:
       *
       *      const tanuloUrlek = ['/szuloi-orarend', '/szuloi-jegyek', ...];
       *      menu = menu.filter((m) => tanuloUrlek.includes(m.url));
       *
       *  Ez eldobta mindazt, amit a jogosultság megadott: hiába kapott a tanulói
       *  jogkör jogot az Étkezésre vagy a Pénzügyre, a menüből kiesett – és a
       *  Jogosultságok képernyőn semmi nem utalt rá, miért. Ugyanez a hiba volt a
       *  TTF-nél a pedagógusokkal.
       *
       *  A menüt a KISZOLGÁLÓ állítja össze (jogosultság + jogkör-öröklés +
       *  elrejtés). A képernyő nem vesz el belőle.
       */
      if (this.currentMode === "SULINFORM" && (loginmode === "tanulo" || jogkor === "tanulo")) {
        const tanuloMenu = [
          { id: -9201, title: 'Órarendem', external: false, url: '/szuloi-orarend', icon: 'calendar', disabled: false, sorrend: 10 },
          { id: -9202, title: 'Jegyeim', external: false, url: '/szuloi-jegyek', icon: 'school', disabled: false, sorrend: 11 },
          { id: -9203, title: 'Dokumentumaim', external: false, url: '/dokumentumaim', icon: 'document-text', disabled: false, sorrend: 12 },
          // Beadandó feladatok (2026-10-15): a tanuló itt adja be őket (backend/beadando.js).
          { id: -9204, title: 'Feladataim', external: false, url: '/feladataim', icon: 'document-attach', disabled: false, sorrend: 13 },
          // Étlap (2026-10-21): mi lesz az ebéd – csak olvasható (backend/etkezes-etlap.js). A tanuló
          // nem rendel, ezért nem az Étkezés képernyőt kapja, hanem ezt.
          { id: -9205, title: 'Étlap', external: false, url: '/etlap', icon: 'restaurant', disabled: false, sorrend: 14 },
        ];
        /*  A beépített három menüpont csak akkor kerül be, ha a tanulói jogkörnek
         *  MÉG EGYETLEN saját-adat képernyőre sincs joga – vagyis a jogosultság nincs
         *  beállítva. Amint az adminisztrátor bármelyiket megadja, a kiszolgáló veszi
         *  át teljesen: onnantól az elrejtés is működik ezeken a pontokon, mert a
         *  képernyő nem tesz vissza olyat, amit ott szándékosan levettek.
         */
        const sajatAdatUrlek = ['/szuloi-orarend', '/szuloi-jegyek', '/dokumentumaim',
                                '/ertekelesek/4', '/etkezes', '/penzugy'];
        const vanSajatAdatMenu = menu.some((m: any) => sajatAdatUrlek.includes(String(m.url || '')));
        if (!vanSajatAdatMenu) {
          for (const item of tanuloMenu) {
            if (!menu.some((menuItem) => menuItem.url === item.url)) menu.push(item);
          }
        }
        menu = menu.sort((a, b) => Number(a.sorrend || 0) - Number(b.sorrend || 0));
        /*  VOLT TANULÓ (megszűnt jogviszony, a /user-tanulo `volt_tanulo` jelzése): a belépés
         *  80 évig megmarad a digitális bizonyítványért (Nkt. 57. § (9a)–(9b)), de a menüben
         *  CSAK a Dokumentumaim áll. Az írást a kiszolgáló is elutasítja (dokumentum-hozzaferes.js). */
        const tanuloMeta: any = await this.data.getFromStorage('userMetadata');
        if (loginmode === 'tanulo' && Number(tanuloMeta?.volt_tanulo) === 1) {
          menu = [{ id: -9203, title: 'Dokumentumaim', external: false, url: '/dokumentumaim', icon: 'document-text', disabled: false, sorrend: 12 }];
        }
      }
      if (this.currentMode === "SULINFORM" && (loginmode === "gondviselo" || jogkor === "gondviselo")) {
        const gondviseloMenu = [
          { id: -9101, title: 'Gyermek órarendje', external: false, url: '/szuloi-orarend', icon: 'calendar', disabled: false, sorrend: 15 },
          { id: -9102, title: 'Dokumentumaim', external: false, url: '/dokumentumaim', icon: 'document-text', disabled: false, sorrend: 16 },
          { id: -9103, title: 'Fogadóóra', external: false, url: '/fogadoora', icon: 'people', disabled: false, sorrend: 17 },
          // Beadandó feladatok (2026-10-15): a gondviselő olvassa a gyermeke feladatait és a visszajelzést.
          { id: -9104, title: 'Feladataim', external: false, url: '/feladataim', icon: 'document-attach', disabled: false, sorrend: 17 },
        ];
        for (const item of gondviseloMenu) {
          if (!menu.some((menuItem) => menuItem.url === item.url)) {
            menu.push(item);
          }
        }
        menu = menu.sort((a, b) => Number(a.sorrend || 0) - Number(b.sorrend || 0));
      }
      /*  FOGADÓÓRA (2026-10-15): a dolgozónak is alapból megjelenik, amíg az adminisztrátor a
       *  Jogosultságokban fel nem veszi (onnantól a kiszolgáló menüje dönt). A végpontok a
       *  kilétet maguk mérik: meghirdetni csak munkatárs, foglalni csak gondviselő tud. */
      if (this.currentMode === "SULINFORM" && loginmode !== "tanulo" && jogkor !== "tanulo"
          && loginmode !== "gondviselo" && jogkor !== "gondviselo" && !menu.some((m: any) => m.url === '/fogadoora')) {
        menu.push({ id: -9301, title: 'Fogadóóra', external: false, url: '/fogadoora', icon: 'people', disabled: false, sorrend: 6 });
        menu = menu.sort((a, b) => Number(a.sorrend || 0) - Number(b.sorrend || 0));
      }
      /*  TANULÓI ADATLAP (2026-11-02, a user kérése): az adminnak az „Adatok” csoportban, a
       *  pedagógusnak önálló főmenüpontként. Amíg a menüszerkesztőben fel nem veszik (a beépített
       *  menükészletben szerepel, jogosultsag.js), innen kerül be; a kiszolgáló dönti el, admin-e,
       *  és azt is, kinek az adatlapját nyithatja meg (backend/tanuloi-adatlap.js). */
      if (this.currentMode === "SULINFORM" && loginmode !== "tanulo" && jogkor !== "tanulo"
          && loginmode !== "gondviselo" && jogkor !== "gondviselo" && !menu.some((m: any) => m.url === '/tanuloi-adatlap')) {
        const adatlapJog = await this.tanuloiAdatlapJog(jogkor);
        if (adatlapJog.munkatars) {
          const adatok: any = adatlapJog.admin ? menu.find((m: any) => m.url === '0/suli-adatok') : null;
          const naplo: any = menu.find((m: any) => m.url === '0/suli-naplo');
          menu.push({ id: -9401, title: 'Tanulói adatlap', external: false, url: '/tanuloi-adatlap', icon: 'id-card', disabled: false,
            main: adatok ? adatok.id : null,
            //  Az Adatok alpontjai a fejléc sorrend×1000 körül állnak; a főmenüben a Napló után.
            sorrend: adatok ? Number(adatok.sorrend || 0) * 1000 + 50 : Number(naplo?.sorrend ?? 4) + 0.5 });
          menu = menu.sort((a, b) => Number(a.sorrend || 0) - Number(b.sorrend || 0));
        }
      }
      // onactive: ha a megadott tároló-kapcsoló hamis, az elemet elrejtjük (nem csak letiltjuk)
      const onactiveCache = new Map<string, boolean>();
      const visibleMenu = [];
      for (const item of menu) {
        if (item.onactive) {
          if (!onactiveCache.has(item.onactive)) {
            onactiveCache.set(item.onactive, !!(await this.data.getFromStorage(item.onactive)));
          }
          if (!onactiveCache.get(item.onactive)) continue; // elrejtés
        }
        visibleMenu.push(item);
      }
      menu = visibleMenu;
      // Almenü-behúzás: a `main` mezőben a szülő menüsor azonosítója áll.
      //
      // FONTOS: a gyerek elemet CSAK akkor húzzuk be (és vesszük ki a felső szintről),
      // ha a szülő fejléc is benne van a listában. Korábban a `filter(m => !m.main)`
      // feltétel nélkül eldobott minden gyereket – ha a fejlécre nem volt jogosultsága a
      // felhasználónak, a gyerek menüpont NÉMÁN ELTŰNT, hiába volt bepipálva a
      // jogosultság-szerkesztőben. A csoportosítás elvesztése sokkal kisebb baj, mint a
      // menüpont elvesztése, ezért ilyenkor felső szinten mutatjuk.
      const behuzott = new Set();
      for (let i = 0; i < menu.length; i++) {
        for (let j = 0; j < menu.length; j++) {
          if (menu[i].main && menu[i].main == menu[j].id) {
            if (!Array.isArray(menu[j].submenu)) menu[j].submenu = []
            menu[j].submenu.push(menu[i])
            behuzott.add(menu[i].id)
            break;
          }
        }
      }
      const arvak = menu.filter(m => m.main && !behuzott.has(m.id));
      if (arvak.length) {
        console.warn('[menu] szülő fejléc nélküli menüpontok, felső szinten mutatjuk:',
          arvak.map((m: any) => m.url));
      }
      menu = menu.filter(m => !m.main || !behuzott.has(m.id))

      /*for (let e of menu) {
        if (e.main != null) {
          for (let f of menu) {
            if (e.main == f.id) {
              if (!Array.isArray(f.submenu)) f.submenu = []
              f.submenu.push(e)
              let removeIndex = menu.map(item => item.id).indexOf(e.id);
              menu.splice(removeIndex, 1);
              //break;
            }
          }
        }
      }*/
      //console.log(menu)
      if (futas !== this.menuFutas) return; // közben egy újabb setMenu indult – az rajzol
      this.appPages = [...lapok, ...menu]
      /*  A jogkör-nézet választója akkor tölthető, amikor az intézmény és a mód már
       *  eldőlt – a lista a felhasználó VALÓDI jogköreiből áll, nem a szűkítettből. */
      this.jogkorNezetBetolt();
      // A kezdőlap (/valaszto) ugyanezekből a pontokból épít csempéket. Azért innen mentjük és
      // nem a nyers /api/menu válaszból, mert itt már lefutott az onactive-rejtés, a kódból
      // injektált menüpontok (Admin, webshop, gondviselő) és az almenü-behúzás is.
      //
      // A MÓDDAL EGYÜTT mentjük: enélkül a kezdőlap nem tudta megkülönböztetni, hogy a tárolt
      // lista az aktuális vagy egy korábbi alrendszeré – alrendszer-váltás után az előző modul
      // menüpontjait rajzolta ki. A publikálás egyben jelzést is küld, mert a kezdőlap
      // ngOnInit-je hamarabb lefuthat, mint ez az aszinkron menüépítés.
      await this.data.publikalMenu(this.currentMode, menu)

      // Az olvasatlan üzenetek jelvénye a bal menün: enélkül csak akkor derül ki, hogy
      // jött üzenet, ha a felhasználó rákattint. Külön, olcsó COUNT megy hozzá.
      this.olvasatlanFrissit();
      this.kretaAllapotFrissit();

      // A tárolt menü azonnal rajzol, de elavulhat: egy ÚJ menüpont (új modul, új
      // jogosultság) csak újbóli belépés után jelent volna meg. Ezért indulásonként
      // egyszer frissítünk a szerverről is – a felhasználónak nem kell kilépnie.
      if (!this.menuFrissitve) {
        this.menuFrissitve = true;
        // SORREND: előbb a jogkör/alrendszer-lista frissül, és CSAK UTÁNA a menü. A menü URL-je
        // a jogkört tartalmazza, tehát elavult jogkörrel elavult – új módban akár üres – menüt
        // kérnénk le.
        this.modokFrissit().then(() => {
          this.refreshMenuFromApi(); this.temaFrissit();
          //  A felhasználó saját beállításai (téma, menüszín) – a Beállítások oldal írja.
          this.felhBeallitas.betolt(this.getCurrentUsername(this.user$)).then(() => this.probaAtvesz());
        });
      }
    } else {
      //this.appPages.push({ title: 'Főoldal', external: false, url: '/faliujsag', icon: 'home' });
    }
  }

  // A fitness admin-szerepkör lekérdezése INNEN KIKERÜLT. A menü nem dönt többé
  // adminjogosultságról: a fejlesztői belépőt a felhasználói alkalmazás Profil
  // képernyője mutatja, és a láthatóságát a beteg-BFF `developerAccess` mezője
  // adja (§1, §12.6). Így nem marad két, egymástól függetlenül karbantartott
  // helye ugyanannak a döntésnek.

  /** Tanulói adatlap a menüben: munkatárs-e és admin-e (intézményenként és jogkör-nézetenként egyszer kérdezve). */
  private tanuloiAdatlapJogTar = new Map<string, Promise<{ admin: boolean; munkatars: boolean }>>();
  private tanuloiAdatlapJog(jogkor: any): Promise<{ admin: boolean; munkatars: boolean }> {
    const intez = String(this.sajatIntezmeny?.intezmenyId || "").replace(/^\/+|\/+$/g, "");
    if (!intez) return Promise.resolve({ admin: false, munkatars: false });
    const kulcs = `${intez}|${JSON.stringify(jogkor ?? "")}`;
    if (!this.tanuloiAdatlapJogTar.has(kulcs)) {
      this.tanuloiAdatlapJogTar.set(kulcs, firstValueFrom(this.http.get<any>(`/api/tanuloi-adatlap/jog/${encodeURI(intez)}`))
        .then((r) => ({ admin: !!r?.admin, munkatars: !!r?.munkatars }))
        //  Hiba esetén pedagógusként tesszük ki (főmenü); a jogot az oldal úgyis a kiszolgálótól kéri.
        .catch(() => { this.tanuloiAdatlapJogTar.delete(kulcs); return { admin: false, munkatars: true }; }));
    }
    return this.tanuloiAdatlapJogTar.get(kulcs)!;
  }

  // Beállítja az 'isOf' kapcsolót: admin jogkör, tényleges osztályfőnök (osztaly.of == username)
  // vagy osztályfőnök-helyettes esetén igaz – a helyettest a kiszolgáló listája már tartalmazza.
  // Ettől függ az "Osztályfőnök" menü láthatósága (menu.onactive = 'isOf').
  async computeOfFlag(): Promise<void> {
    try {
      if (this.currentMode !== "SULINFORM") { await this.data.setStorage("isOf", false); return; }
      //  A BEKÖTÖTT azonosítóval kérdezünk: a belépési név és a nyilvántartásbeli
      //  azonosító nem mindig ugyanaz, és itt az utóbbi a kérdés. Az admin-jogot a
      //  kiszolgáló dönti el – a böngészőben tárolt jogkör elavult is lehet.
      const username = this.sajatAzonosito();
      const intez = String(this.sajatIntezmeny?.intezmenyId || "").replace(/^\/+|\/+$/g, "");
      if (!intez) { await this.data.setStorage("isOf", false); return; }
      const url = `/api/of/osztalyok/${encodeURI(intez)}?username=${encodeURIComponent(username || "")}`;
      const rsp: any = await firstValueFrom(this.http.get(url));
      await this.data.setStorage("isOf", !!rsp?.admin || (rsp?.osztalyok?.length || 0) > 0);
    } catch (e) {
      console.error("isOf flag hiba:", e);
      await this.data.setStorage("isOf", false);
    }
  }

  /**
   *  A bal menü frissítése a szerverről.
   *
   *  A menü a tárolóból (`storage.menu`) rajzolódik, hogy azonnal ott legyen betöltéskor.
   *  Emiatt viszont egy ÚJ menüpont (pl. új modul) csak újbóli belépés után jelent meg –
   *  a felhasználó hiába kapta meg a jogosultságot. Ezért ezt minden alkalmazás-indításkor
   *  meghívjuk: a tárolt lista adja a gyors rajzolást, a szerver válasza pedig felülírja.
   */
  async refreshMenuFromApi() {
    if (!this.currentMode || !this.sajatIntezmeny?.intezmenyId) return;

    const jogkor = await this.data.getJogkor();
    if (!jogkor) return;

    this.http
      .get(
        '/api/menu/' + this.currentMode + '/' + jogkor + '/' + this.sajatIntezmeny.intezmenyId,
      )
      .subscribe({
        next: async (response: any) => {
          await this.data.setStorage("menu", response)
          this.setMenu(this.userMetadata);
        },
        error: (error) => {
          console.error('Error refreshing menu:', error);
          this.setMenu(this.userMetadata);
        }
      });
  }
  /*  ALRENDSZER-VÁLTÁS. A `celUrl` az a képernyő, ahol a váltás után landolni akarunk – ezt az
   *  adja meg, aki KONKRÉT helyre visz át (pl. a Könyvelés ügyfélkártyájáról a bérszámfejtés
   *  Alkalmazottak lapjára). Enélkül a semleges „választó" kezdőlap jön: a fejléc váltójából
   *  nem tudjuk, hova készül a felhasználó, és az előző modul oldalán maradni rossz volna. */
  async selectChangedUzemmod(e, celUrl?: string) {
    let loading = await this.loadingCtrl.create({
      message: 'Adatok lekérése...',
    });
    //console.log(e)
    loading.present();
    try {
      await this.data.setStorage("currentMode", e[0].name)
      this.currentMode = e[0].name
      //window.location.reload()
      await this.selectChangedIntezmeny([], true, celUrl)
    } finally {
      // Siker esetén úgyis újratölt az oldal; hiba esetén viszont ne maradjon fent a pörgő.
      try { await loading.dismiss(); } catch (e2) { /* ignore */ }
    }
  }
  /**
   *  A bal menü tanév-választójának felirata.
   *
   *  A régi megoldás `tanevadatok[aktualistanev - elsotanev].name` indexeléssel dolgozott,
   *  ami azt feltételezte, hogy a tanévek hézagmentes sorban követik egymást az `elsotanev`-től.
   *  Ha az `elsotanev` üres, vagy a tanévek nem folytonosak (pl. új tanév létrehozása után),
   *  az index NaN/tartományon kívüli lett → `undefined.name` → a teljes oldalsáv sablonja
   *  kivételt dobott, és „összeomlott" az oldal. Itt már azonosító szerint keresünk.
   */
  munkatanevNev(): string {
    const lista = Array.isArray(this.tanevadatok) ? this.tanevadatok : [];
    const ev = this.valasztottTanev ?? this.tanev?.aktualistanev;
    const sor = lista.find((t: any) => String(t?.id) === String(ev));
    return sor?.name || (ev != null ? String(ev) : 'Tanév');
  }

  /**
   *  Tanévváltás a bal menüből. KORÁBBAN ez az `selectChangedIntezmeny`-t hívta, tehát a
   *  kiválasztott TANÉV objektumot intézményként dolgozta fel: felülírta a `sajatIntezmeny`
   *  tárolót, és `jogkor/undefined` URL-t hívott → szétesett a munkamenet.
   *
   *  Az intézmény aktuális tanévét (`feladatellatas.aktualistanev`) ez NEM írja át – azt
   *  kizárólag a tanévváltó „Megnyitás" gombja teheti. Itt a MUNKATANÉV áll át: a
   *  törzsadat-felületek (osztály, csoport, tantárgyfelosztás, terem) erre az évre dolgoznak.
   */
  async selectChangedTanev(e) {
    const valasztott = Array.isArray(e) ? e[0] : e;
    const ev = valasztott?.id;
    if (ev == null) return;
    if (String(ev) === String(this.valasztottTanev)) return;

    await this.data.setMunkatanev(Number(ev));
    this.valasztottTanev = Number(ev);
    const aktualis = this.tanev?.aktualistanev;
    this.data.sendToast(
      String(ev) === String(aktualis)
        ? 'Az aktuális tanévre váltottál.'
        : `Munkatanév: ${this.munkatanevNev()}. A törzsadat-felületek erre az évre dolgoznak, `
          + 'a napló és az értékelés az aktuális tanévén marad.',
      'success');
    // Az oldalak a betöltéskor olvassák ki a munkatanévet, ezért újratöltjük a nézetet.
    window.location.reload();
  }

  async selectChangedIntezmeny(e, secondary = false, celUrl?: string) {
    if (secondary) e[0] = this.sajatIntezmeny
    let loading = await this.loadingCtrl.create({
      message: 'Adatok lekérése...',
    });
    loading.present();

    // ROBUSZTUS átírás: try/catch + GARANTÁLT loading.dismiss(). A régi verzióban egyik beágyazott
    // subscribe-nak sem volt `error` ága, és a loading-ot csak a sikeres ág végi reload zárta be –
    // így bármilyen hiba (pl. null jogkör → hibás URL, vagy hálózati hiba) ÖRÖKRE fent ragadt
    // spinnert ("beakad") okozott. Most minden hiba esetén bezárjuk a loadingot és jelzünk.
    try {
      // A dropdownból jövő entry mezői (mode/color/…) nyers JSON-stringek – parse-oljuk,
      // különben reload után a `sajatIntezmeny.mode.map(...)` STRING-en hasal el (üres menü).
      this.parseIntezmenyFields(e[0]);
      // Fixált alrendszernél (több-app matrix) a currentMode MINDIG a fixedMode marad – nem váltunk mainmode-ra.
      if (this.fixedMode) {
        this.currentMode = this.fixedMode;
        await this.data.setStorage("currentMode", this.fixedMode);
      }
      // Ha az aktuális mód a CÉL intézményben nem elérhető, váltsunk a cél mainmode-jára,
      // különben a jogkor/access/menü lekérés a nem támogatott módra üres menüt adna.
      else if (Array.isArray(e[0].mode) && this.currentMode && !e[0].mode.includes(this.currentMode)) {
        this.currentMode = e[0].mainmode || e[0].mode[0];
        await this.data.setStorage("currentMode", this.currentMode);
      }
      const iid = e[0].intezmenyId;
      const response2 = await firstValueFrom(this.http.get('/api/jogkor/' + this.currentMode + '/' + iid));
      await this.data.setStorage("jogkor", response2);
      if (e[0].jogkor) e[0].jogkor = this.parseJogkor(e[0].jogkor);
      await this.data.setStorage("sajatIntezmeny", e[0]);

      const umd = await this.data.getFromStorage("userMetadata");
      if (umd) {
        umd.department = await this.data.getJogkor(response2);
        await this.data.setStorage("userMetadata", umd);
      }

      const jk = await this.data.getJogkor();
      const response3: any = await firstValueFrom(this.http.get('/api/access/' + this.currentMode + '/' + jk + '/' + iid));
      try { await this.data.setStorage("access", JSON.parse(response3.url)); }
      catch (e2) { await this.data.setStorage("access", []); }

      const response4 = await firstValueFrom(this.http.get('/api/menu/' + this.currentMode + '/' + jk + '/' + iid));
      await this.data.setStorage("menu", response4);

      // Modulváltáskor (secondary) NE az előző modul oldala maradjon a képernyőn: átnavigálunk a
      // megadott célra – vagy ha nincs, a semleges „választó" landingre –, majd reload (az új
      // modul menüje a bal oldalon jelenik meg).
      if (secondary) { try { await this.router.navigateByUrl(celUrl || '/valaszto'); } catch (e5) { /* ignore */ } }
      window.location.reload();
    } catch (err) {
      console.error('Alrendszer-váltás hiba:', err);
      try { await loading.dismiss(); } catch (e3) { /* ignore */ }
      try { window.alert('Az alrendszer-váltás nem sikerült. Ellenőrizd a kapcsolatot, és próbáld újra.'); } catch (e4) { /* ignore */ }
    }
    /*this.showLoading('Adatok lekérése...');
    //console.log(e)
    //console.log(this.ports)
    this.ports = this.portsDef.filter(d => {
      for(let i = 0; i< d.intezmenyadatok.length; i++){
        if(d.intezmenyadatok[i].intezmenyId == e[0].intezmenyId){
          return true;

        }
      }
      return false;
    }).sort((a, b) => (a.viselt_vez > b.viselt_vez) ? 1 : ((b.viselt_vez > a.viselt_vez) ? -1 : 0));
    this.sajatIntezmeny = e[0]
    this.getData(this.selectedYear, this.selectedMonth);
*/
  }

  /**
   *  KÜLSŐ MENÜPONT MEGNYITÁSA.
   *
   *  A „külső hivatkozás" jelölés pontosan azt jelenti, hogy a cím NEM az alkalmazás
   *  része. Eddig mégis a belső útvonalkezelőnek adtuk át (`navigateByUrl`), ami egy
   *  https-címre nem tud mit kezdeni: a felület vagy üres oldalra váltott, vagy
   *  ugyanott maradt – a link „nem csinált semmit".
   *
   *  Most a teljes (protokollos vagy protokoll-relatív) címet ÚJ LAPON nyitjuk, a
   *  `noopener` miatt a megnyitott oldal nem fér hozzá a mi ablakunkhoz. Ami nem
   *  abszolút cím, az továbbra is belső útvonal – ott a régi viselkedés a helyes.
   */
  async openWindow(url) {
    try { await this.almenumodal.dismiss(); } catch (error) { /* nem volt nyitva */ }

    const cim = String(url || '').trim();
    const kulso = /^(https?:)?\/\//i.test(cim) || /^(mailto|tel):/i.test(cim);
    if (kulso) {
      window.open(cim, '_blank', 'noopener,noreferrer');
      return;
    }
    this.router.navigateByUrl(cim);
  }
  openMenu(url) {
    this.menu = url.submenu
    this.almenumodal.present()
  }

  openSlide(i) {
    for (let j = 0; j < this.appPages.length; j++) {
      if (j == i) {
        document.getElementById("slide-" + i).style.height = "100%"
        this.ref.detectChanges()
      } else
        if (document.getElementById("slide-" + j)) { document.getElementById("slide-" + j).style.height = "0px"; this.ref.detectChanges() }
    }

  }

  /** Kézi újrabelépés az indulási hibaképernyőről. */
  ujraBelepes() {
    try { sessionStorage.removeItem(this.ujraBelepesKulcs); localStorage.clear(); } catch { /* ignore */ }
    this.bootHiba = '';
    // Ha a discovery sem töltődött be, a `login()` nem tudna hova irányítani –
    // ilyenkor teljes újratöltés kell, hogy az indulás elölről fusson.
    if (this.auth.indulasiHiba) { this.oldalFrissites(); return; }
    this.auth.login();
  }

  /** Teljes újratöltés – ha a belépés sem indul el. */
  oldalFrissites() { window.location.href = window.location.origin + '/'; }

  async login() {

    /*this.auth
      .loginWithRedirect({
        async openUrl(url: string) {
          return Browser.open({ url, windowName: '_self' });
        },
      })
      .subscribe();*/
  }
  /**
   *  Kijelentkezés. Alapból csak EBBŐL a rendszerből – a föderált (Microsoft) belépés
   *  nem szűnik meg tőle. A teljes, mindenhonnan való kilépéshez `logout(true)`.
   */
  logout(mindenhonnan = false) {
    this.auth.logout(mindenhonnan)
    /*this.auth
      .logout({
        logoutParams: {
          returnTo: callbackUri,
        },
        async openUrl(url: string) {
          return Browser.open({ url, windowName: '_self' });
        },
      })
      .subscribe();*/
  }

  /**
   *  Az identitásból kiolvasható ÖSSZES azonosító-jelölt, sorrendben.
   *
   *  Föderált (Microsoft/Entra) belépésnél nem garantált, hogy a `preferred_username`
   *  az e-mail cím: lehet UPN, de lehet GUID is, és ilyenkor a cím csak az `email`
   *  claimben van meg. A tanulót viszont éppen az E-MAIL köti a rendszerhez (a KIR nem
   *  ad címet), ezért mindegyik alakot végigpróbáljuk, nem csak az elsőt.
   */
  private azonositoJeloltek(): string[] {
    const u: any = this.user$ || {};
    return [...new Set([u.username, u.preferred_username, u.email, u.upn]
      .map((x) => String(x || '').trim().toLowerCase()).filter(Boolean))];
  }

  /** Az első azonosító-jelölt, amelyre a végpont értelmes választ ad. */
  private async elsoTalalat(vegpont: string): Promise<any> {
    for (const azonosito of this.azonositoJeloltek()) {
      try {
        const valasz: any = await firstValueFrom(
          this.http.get(vegpont + encodeURIComponent(azonosito)));
        if (Array.isArray(valasz) && valasz[0]?.intezmenyadatok) return valasz;
      } catch (e) { /* a következő jelölt jön */ }
    }
    return null;
  }

  /**
   *  A BELÉPÉS BEKÖTÉSE – a kiszolgáló mondja meg, ki a belépő.
   *
   *  Akkor hívjuk, ha a belépés sikerült, de a nyilvántartásban a belépési néven nincs
   *  senki. A kiszolgáló a TOKENBŐL dolgozik (nevet nem küldünk neki: azzal bárki
   *  bárkinek a nevére kérhetne bekötést), és ha egyértelműen feloldja, kit takar a
   *  név, visszaadja a nyilvántartásbeli azonosítót. Innentől azzal dolgozunk.
   *
   *  Élesben ez a gondviselők esete: a törzsadatuk az EGYIK gyerekük azonosítóján áll,
   *  a belépési fiókjuk a MÁSIKÉN – ugyanaz az ember, két néven.
   */
  private async belepestBekot(): Promise<any> {
    try {
      const valasz: any = await firstValueFrom(this.http.post('/api/belepes-bekotes', {}));
      if (!valasz?.ok || !valasz?.azonosito) return null;

      const fajta = String(valasz.fajta || '');
      const mod = fajta === 'gondviselo' ? 'gondviselo' : (fajta === 'tanulo' ? 'tanulo' : 'dolgozo');
      const url = mod === 'dolgozo' ? '/api/user/' : `/api/user-${mod}/`;
      const adat: any = await firstValueFrom(this.http.get(url + encodeURIComponent(valasz.azonosito)));
      if (!Array.isArray(adat) || !adat[0]?.intezmenyadatok) return null;

      this.loginmode = mod;
      await this.data.setStorage('loginmode', mod);
      /*  A bekötést a BELÉPÉSI NÉVHEZ kötjük. Ugyanazon a gépen más is bejelentkezhet:
       *  ha a jelölés névtelen volna, a következő felhasználó az előző azonosítóját
       *  örökölné meg – és az ő adatait kérné le. */
      try {
        localStorage.setItem('cronom_bekotes', JSON.stringify({
          nev: String(this.user$?.preferred_username || this.user$?.username || '').toLowerCase(),
          azonosito: valasz.azonosito,
          fajta,
        }));
      } catch (e) { /* privát ablak – a bekötés így is működik, csak minden belépésnél újra kell kérni */ }
      console.log(`[bekotes] a belépés bekötve: ${valasz.azonosito} (${valasz.mod})`);
      return adat;
    } catch (e) {
      return null;
    }
  }

  /**
   *  A SAJÁT NYILVÁNTARTÁSBELI AZONOSÍTÓ – bekötéssel és nézetváltással együtt.
   *  Ahol a kiszolgálónak azt kell megmondani, KIRŐL van szó, ezt kell küldeni.
   */
  private sajatAzonosito(): string {
    const k: any = this.data.belepoKilet(this.user$) || {};
    return String(k.preferred_username || k.username || '').trim();
  }

  private getCurrentUsername(identityClaims: any): string {
    return String(
      identityClaims?.username ||
      identityClaims?.preferred_username ||
      identityClaims?.email ||
      ''
    ).trim().toLowerCase();
  }

  private async loadCurrentIdentity(): Promise<any> {
    try {
      await this.oauth.loadUserProfile();
    } catch (error) {
      console.warn('User profile could not be loaded yet', error);
    }

    let claims = this.oauth.getIdentityClaims() as any;

    for (let i = 0; i < 10 && !this.getCurrentUsername(claims); i++) {
      await new Promise(resolve => setTimeout(resolve, 200));
      claims = this.oauth.getIdentityClaims() as any;
    }

    return claims;
  }

  // Az allomany_feladatellatas.jogkor mező lehet valódi JSON (tömb pl. ["admin"] vagy
  // mód-szerinti objektum pl. {"SULINFORM":["admin"]}), VAGY ha csak 1 jogkör van, sima
  // szöveg (pl. "admin"). A korábbi JSON.parse az utóbbira hibát dobott. Ez biztonságosan kezeli:
  //  - valódi JSON ({…} / […]) → parse-olva,
  //  - idézett string ("admin") → ["admin"],
  //  - sima egyetlen érték (admin) → ["admin"] (így a getJogkor tömb-ága kezeli).
  private parseJogkor(val: any): any {
    if (val === null || val === undefined || val === '') return val;
    if (typeof val !== 'string') return val;
    const s = val.trim();
    if (s.startsWith('[') || s.startsWith('{')) {
      try { return JSON.parse(s); } catch { /* nem valódi JSON, lásd lentebb */ }
    }
    if (s.startsWith('"') && s.endsWith('"')) {
      try { return [JSON.parse(s)]; } catch { /* fall through */ }
    }
    return [s];
  }

  // A /api/user válaszban az intézményenkénti (intezmenyadatok) mezők nyers JSON-STRINGEK
  // (mode, color, color_secondary, color_shade), és csak az elsődleges intézményre parse-olódnak
  // a bootstrapban. Intézményváltáskor a dropdownból jövő nyers entry-t mentettük sajatIntezmeny-ként,
  // így reload után a `sajatIntezmeny.mode.map(...)` egy STRING-en futott → TypeError → üres menü.
  // Ez a helper biztonságosan (idempotensen) parse-olja ezeket, akárhányszor hívjuk.
  private parseIntezmenyFields(entry: any): any {
    if (!entry || typeof entry !== 'object') return entry;
    const parseIf = (v: any) => {
      if (typeof v !== 'string') return v;         // már parse-olva vagy nem string
      const s = v.trim();
      if (!s) return v;
      try { return JSON.parse(s); } catch { return v; }
    };
    entry.mode = parseIf(entry.mode);
    entry.color = parseIf(entry.color);
    entry.color_secondary = parseIf(entry.color_secondary);
    entry.color_shade = parseIf(entry.color_shade);
    if (entry.jogkor) entry.jogkor = this.parseJogkor(entry.jogkor);
    return entry;
  }

  private getStoredUsername(storedUser: any, storedMetadata: any): string {
    return String(
      storedUser?.username ||
      storedUser?.preferred_username ||
      storedUser?.email ||
      storedMetadata?.username ||
      storedMetadata?.email ||
      ''
    ).trim().toLowerCase();
  }

  private hasLogoutPendingFlag(): boolean {
    try {
      return sessionStorage.getItem(this.logoutPendingKey) === '1'
        || localStorage.getItem(this.logoutPendingKey) === '1';
    } catch (error) {
      return false;
    }
  }

  private clearLogoutPendingFlag(): void {
    try {
      sessionStorage.removeItem(this.logoutPendingKey);
      localStorage.removeItem(this.logoutPendingKey);
    } catch (error) {
      console.warn('Failed to clear logout pending flag', error);
    }
  }

  private async resetApplicationSession(): Promise<void> {
    await this.data.clearStorage();

    /*  A BEKÖTÉS-JELÖLÉS IS MENJEN. Ez localStorage-ban él (a kilét-feloldásnak
     *  szinkronban kell rendelkezésre állnia), tehát a tárhely-ürítés nem viszi el –
     *  ha maradna, a következő belépő az előző azonosítóját örökölné. */
    try { localStorage.removeItem('cronom_bekotes'); } catch (error) { /* privát ablak */ }

    try {
      sessionStorage.clear();
    } catch (error) {
      console.warn('Failed to clear sessionStorage', error);
    }

    this.user$ = null;
    this.userMetadata = null;
    this.sajatIntezmeny = null;
    this.selectedUser = null;
    this.migracio = false;
    this.intezmenyek = [];
    this.loginmode = "dolgozo";
    this.tanev = null;
    this.tanevadatok = null;
    this.currentMode = null;
    //  A frissítés-jelzés adminisztrátori információ: kilépéskor nem maradhat a képernyőn.
    this.ujVerzio = null;
    this.frissitesElerheto = null;
    this.frissitesUtoljara = 0;
    this.modes = [];
    this.menu = [];
    this.kivceg = null;
    this.appPages = [];
  }

  // A PDF-motor (LibreOffice) beszerzésének követése: a backend tölti le első indításkor, mi
  // pollozzuk az állapotot és egy jobb alsó toastban mutatjuk (letöltés %, kicsomagolás, kész).
  figyeljPdfMotor() {
    //  A PDF-motor (LibreOffice) a CAESAR modulé. Az asztali programokban (window.CRONOM_ASZTALI a
    //  program-szervertől) CSAK a CAESAR-nál van értelme figyelni – más programban (pl. Könyvelés) ez
    //  fölösleges /api/caesar/pdf-motor-statusz hívás-özön (belépés előtt 401, más telepítésen 404).
    const asztaliMod = String((window as any).CRONOM_ASZTALI?.mod || '').toUpperCase();
    if (asztaliMod && asztaliMod !== 'CAESAR') return;
    let hibaDb = 0;
    const poll = () => {
      this.http.get<any>('/api/caesar/pdf-motor-statusz', { headers: { 'X-Silent': 'true' } }).subscribe({
        next: (s) => {
          hibaDb = 0;
          const aktiv = s && (s.allapot === 'letoltes' || s.allapot === 'kicsomagolas');
          if (aktiv) {
            this.pdfMotorLatottAktiv = true;
            const cim = s.allapot === 'letoltes' ? 'A PDF-motor letöltése' : 'A PDF-motor kicsomagolása';
            this.pdfMotor = { show: true, allapot: s.allapot, uzenet: cim, szazalek: s.szazalek || 0, hiba: false, kesz: false };
            setTimeout(poll, 2500);
          } else if (s && s.allapot === 'kesz') {
            if (this.pdfMotorLatottAktiv) {
              this.pdfMotor = { show: true, allapot: 'kesz', kesz: true, hiba: false, szazalek: 100,
                uzenet: 'A PDF-motor készen áll – készíthetsz iratokat.' };
              setTimeout(() => { this.pdfMotor.show = false; }, 6000);
            }
          } else if (s && s.allapot === 'hiba') {
            this.pdfMotor = { show: true, allapot: 'hiba', hiba: true, kesz: false, szazalek: 0,
              uzenet: s.uzenet || 'A PDF-motor letöltése nem sikerült.' };
            setTimeout(() => { this.pdfMotor.show = false; }, 12000);
          }
          // 'nincs'/'gotenberg'/'ismeretlen' → nincs teendő (nem mutatunk semmit)
        },
        error: (hiba) => {
          /*  A 404 VÉGLEGES válasz, nem átmeneti hiba.
           *
           *  A helyi PDF-motor a CAESAR modulé, és az iskolai telepítéseken nincs is
           *  bekapcsolva (ott a dokumentumokat a Gotenberg szolgáltatás alakítja PDF-fé).
           *  Ilyenkor a végpont nem létezik - ezt 24-szer újrapróbálni két percen át
           *  értelmetlen kérés-özön minden oldalbetöltésnél.
           */
          //  A 404 (nincs CAESAR PDF-motor) és a 401/403 (nincs belépve / nincs jogosultság) VÉGLEGES –
          //  ezeket újrapróbálni értelmetlen kérés-özön (a 401 belépés előtt minden /api-n jön).
          if (hiba?.status === 404 || hiba?.status === 401 || hiba?.status === 403) return;
          // Egyéb hiba (a backend még nem áll, hálózat): pár percig újrapróbáljuk.
          if (++hibaDb <= 24) setTimeout(poll, 5000);
        },
      });
    };
    poll();
  }

  /*  BERAGADT OVERLAY ŐRKUTYA. Ritka Ionic-hiba: egy modal/popover rosszul záródik, és a fő tartalom
   *  `aria-hidden`/`inert` marad, vagy árva `ion-backdrop` ragad a DOM-ban → minden kattintás elnyelve,
   *  csak az oldal újratöltése segít (a user a BÉR fül-sávnál jelezte, de bármelyik modulban előfordulhat).
   *  Másodpercenként ellenőriz: ha SEMMILYEN overlay/menü nincs nyitva (se animáció), de maradt árva
   *  inert/backdrop KÉT egymás utáni körben, feloldja – így magától helyreáll, reload nélkül. Nyitott
   *  overlaynál SOHA nem nyúl semmihez. A zónán kívül fut (nincs change-detection teher). */
  private beragadtOverlayFigyelo() {
    const nyitottVan = () => !!document.querySelector(
      'ion-modal:not(.overlay-hidden), ion-popover:not(.overlay-hidden), ion-alert, ion-action-sheet, ion-picker, ion-select-popover, ion-menu.show-menu, .menu-content-open');
    let gyanus = 0;
    let loadingOta: number | null = null;   // mióta van NYITOTT ion-loading a DOM-ban
    const kor = () => {
      try {
        //  BERAGADT BETÖLTÉS-SPINNER. A leggyakoribb beakadás: egy loading.present() után a dismiss()
        //  elmarad (hiba-ág vagy be nem záró util), így az ion-loading a képernyőn marad és MINDEN
        //  kattintást elnyel – a gomb „nem reagál". Ezt a watchdog eddig NEM oldotta fel (valódi
        //  overlaynak vette). Most: ha NINCS folyamatban HTTP és már >8 mp nyitva (a művelet rég kész),
        //  VAGY abszolút vészfékként >45 mp → bezárjuk. Folyamatban lévő HTTP alatt (<45 mp) nem nyúlunk hozzá.
        const loadings = Array.from(document.querySelectorAll('ion-loading'));
        if (loadings.length) {
          if (loadingOta == null) loadingOta = Date.now();
          const nyitva = Date.now() - loadingOta;
          const nincsHttp = (this.loading && this.loading.active$) ? this.loading.active$.value === false : true;
          if ((nincsHttp && nyitva > 8000) || nyitva > 45000) {
            loadings.forEach((l) => { try { (l as any).dismiss(); } catch (e) { /* */ } try { l.remove(); } catch (e) { /* */ } });
            console.warn(`[overlay-őr] beragadt betöltés-spinner feloldva (${Math.round(nyitva / 1000)} mp, http=${!nincsHttp})`);
            loadingOta = null;
          }
          return;   // amíg ion-loading van a DOM-ban, a backdrop/inert ágat nem futtatjuk
        }
        loadingOta = null;
        if (nyitottVan()) { gyanus = 0; return; }
        const backdrop = Array.from(document.querySelectorAll('ion-backdrop'))
          .filter((b) => !b.closest('ion-modal, ion-popover, ion-alert, ion-action-sheet, ion-loading, ion-picker, ion-menu'));
        //  FONTOS: az Ionic a háttérben hagyott (nem aktív) oldalakat SZÁNDÉKOSAN rejti `.ion-page-hidden`
        //  + aria-hidden-nel (vissza-navigációhoz) – azokat NEM bántjuk. Csak a router-outlet, ill. az
        //  AKTÍV (nem .ion-page-hidden) oldal téves inertjét oldjuk fel.
        const inert = Array.from(document.querySelectorAll(
          'ion-router-outlet[aria-hidden="true"], ion-router-outlet[inert], .ion-page:not(.ion-page-hidden)[aria-hidden="true"], .ion-page:not(.ion-page-hidden)[inert]'));
        if (!backdrop.length && !inert.length) { gyanus = 0; return; }
        if (++gyanus < 2) return;                 // két kör: ne egy nyitó/záró animáció közepén avatkozzunk
        gyanus = 0;
        backdrop.forEach((b) => b.remove());
        inert.forEach((el) => { el.removeAttribute('aria-hidden'); (el as HTMLElement).removeAttribute('inert'); });
        if (backdrop.length || inert.length) console.warn(`[overlay-őr] beragadt maradvány feloldva: ${backdrop.length} backdrop, ${inert.length} inert`);
      } catch (e) { /* a figyelő sosem állíthatja meg az appot */ }
    };
    this.ngZone.runOutsideAngular(() => setInterval(kor, 1200));
  }

  /** Belépés nélkül is olvasható oldal-e az aktuális (a routing-modulban őr nélküli útvonalak). */
  private nyilvanosOldal(): boolean {
    const ut = window.location.pathname || '';
    return /^\/(akadalymentesseg|adatkezeles|ellenorzes)(\/|$)/.test(ut);
  }

  public async ngOnInit() {
    this.beragadtOverlayFigyelo();
    this.ngZone.run(async () => {
      await this.data.init();
      this.ngSelectConfig()
      try { this.figyeljPdfMotor(); } catch (e) { /* nem kritikus */ }

      // Initialize storage if not already done
      //this.storage?.create();

      // Ha a bejelentkezés el sem tudott indulni, azt MONDJUK MEG. Enélkül a
      // képernyő üres marad, és a felhasználónak semmi nem árulja el, hogy
      // nem ő rontott el valamit.
      if (this.auth.indulasiHiba) {
        this.bootHiba = this.auth.indulasiHiba;
        this.ref.detectChanges();
        return;
      }

      /*  Frissítés-ellenőrzés: nem blokkolja az indulást (nem is várjuk meg), és a
       *  nem-adminoknál csendben elszáll. Késleltetve indul, hogy ne versenyezzen a
       *  bootstrap-lekérésekkel. */
      this.verzioBetoltese();
      setTimeout(() => { this.frissitesEllenorzes(); }, 4000);

      const logoutPending = this.hasLogoutPendingFlag();
      const standalone = this.auth.isStandalone();
      const standaloneLogin = this.auth.isStandaloneLogin();
      // Jelszavas standalone: csak érvényes helyi token esetén vagyunk bent (különben a guard a /login-ra visz).
      this.isLoggedIn = standaloneLogin
        ? this.auth.hasValidLocalToken()
        : (standalone || this.oauth.hasValidAccessToken())

      if (!this.isLoggedIn) {
        const hasCachedSession = !!(
          await this.data.getFromStorage("userMetadata")
          || await this.data.getFromStorage("user")
          || await this.data.getFromStorage("sajatIntezmeny")
          || await this.data.getFromStorage("menu")
        );

        if (logoutPending || hasCachedSession) {
          await this.resetApplicationSession();
        }

        this.clearLogoutPendingFlag();

        // ITT VOLT A FEHÉR LAP.
        //
        // Lejárt munkamenetnél idáig jutottunk: kitakarítottuk a tárolót, és
        // `return`-nel kiléptünk. Átirányítás nem történt, kirajzolni pedig
        // már nem volt mit – a felhasználó egy üres oldalt kapott,
        // hibaüzenet nélkül. Aki most jött először (nincs mit takarítani),
        // annál a guard elindította a belépést, ezért a hiba CSAK azt érintette,
        // aki korábban már használta az alkalmazást.
        //
        // A kijelentkezés más eset: ott a megállás a helyes viselkedés –
        // különben azonnal visszaléptetnénk, és sosem lehetne kilépni.
        //  A nyilvános (belépés nélküli) oldalakról – akadálymentesítési nyilatkozat, okirat-
        //  ellenőrzés – nem léptetünk újra: aki ott van, olvasni akar, nem belépni.
        if (!logoutPending && hasCachedSession && !standalone && !standaloneLogin && !this.nyilvanosOldal()) {
          // Egyszer próbálunk újra belépni. Ha az sem sikerül, NEM megyünk
          // körbe-körbe: megmondjuk, mi történt. A néma hurok ugyanolyan
          // használhatatlan, mint a fehér lap.
          if (sessionStorage.getItem(this.ujraBelepesKulcs) !== '1') {
            try { sessionStorage.setItem(this.ujraBelepesKulcs, '1'); } catch { /* ignore */ }
            this.auth.login();
            return;
          }
          this.bootHiba = 'A munkameneted lejárt, és az automatikus újrabelépés nem sikerült. '
            + 'Frissítsd az oldalt, vagy jelentkezz be újra.';
          this.ref.detectChanges();
        }
        return;
      }
      // Sikeres belépés után a próbálkozás-jelölő nem maradhat ott: különben a
      // következő lejáratkor már az első kísérlet is „másodiknak" számítana.
      try { sessionStorage.removeItem(this.ujraBelepesKulcs); } catch { /* ignore */ }
      //if(!this.auth.isLoggedIn){ this.login(); return}
      let url = "";
      /*await this.keycloak.loadUserProfile();
      this.user$ = this.keycloak.getKeycloakInstance().profile as KeycloakProfile & {
        attributes?: Record<string, string | string[]>;
      };*/
      // Standalone módban nincs OIDC identitás – jelszavas módnál a tokenből, fix módnál a beállított userből.
      const standaloneUname = standaloneLogin ? this.auth.localUsername() : this.auth.standaloneUser;
      this.user$ = standalone
        ? { username: standaloneUname, preferred_username: standaloneUname }
        : await this.loadCurrentIdentity();

      /*  NÉZETVÁLTÁS: innentől a bootstrap a CÉL felhasználót tölti be.
       *
       *  Egyetlen ponton avatkozunk be – a személyazonosságnál –, és onnantól a
       *  meglévő útvonal dolgozik: ugyanaz a /user lekérés, ugyanaz a menü- és
       *  jogkör-felépítés. Enélkül a nézetváltásnak le kellene másolnia a teljes
       *  belépési láncot, ami előbb-utóbb elcsúszna az eredetitől.
       */
      this.impersonalas = this.impersonalasOlvas();
      this.jogkorNezet = this.jogkorNezetOlvas();
      if (this.impersonalas?.cel) {
        this.user$ = { username: this.impersonalas.cel, preferred_username: this.impersonalas.cel };
        this.loginmode = this.impersonalas.tipus || 'dolgozo';
      }

      const storedUser = await this.data.getFromStorage("user");
      const storedMetadata = await this.data.getFromStorage("userMetadata");
      const currentUsername = this.getCurrentUsername(this.user$);
      const storedUsername = this.getStoredUsername(storedUser, storedMetadata);

      if ((logoutPending || (storedUsername && currentUsername && storedUsername !== currentUsername))) {
        await this.resetApplicationSession();
      }

      this.clearLogoutPendingFlag();

      if (!currentUsername) {
        console.warn('Authenticated session is present, but identity claims are not ready yet.');
        return;
      }


      this.http
        .get(
          '/api/egyenleg/' + this.user$.username,
          {
            //headers: headers,
          }
        )
        .subscribe({
          next: async (response10: any) => {

            await this.data.setStorage("egyenleg", response10)

          }
        });

      //  Push-eszköz regisztrálása MINDEN indításkor (nem csak az első belépéskor), de
      //  megszemélyesítés közben nem: az a célszemély nevére regisztrálná az admin telefonját.
      if (this.isLoggedIn && !this.impersonalas) this.pushKonfig()
      if (this.isLoggedIn && await this.data.getFromStorage("userMetadata") == null) {//
        console.log(this.user$)
        // Standalone-ban a helyi user dolgozó (admin) – az identitásban nincs jogkör-claim,
        // ezért NE váltsunk emiatt gondviselő módra (azt a /user-gondviselo végpont szolgálná ki).
        // Nézetváltásnál a belépési mód a CÉL típusából jön, nem az admin tokenjéből –
        // az admin tokenjében ugyanis dolgozói jogkör van, ami felülírná a szülői nézetet.
        if (!standalone && !this.impersonalas && (!this.user$["jogkor"] || this.user$["jogkor"].includes("gondviselo"))) this.loginmode = "gondviselo"
        // TANULÓI belépés: a diák ugyanazon az IdP-n jön be, mint a tanárok (Microsoft-fiók).
        // Ha az IdP küld 'tanulo' jogkört, abból tudjuk; ha nem (federált fiókoknál gyakori),
        // a lekérdezés üres válasza után esünk vissza rá – lásd lentebb.
        if (!standalone && !this.impersonalas && this.user$["jogkor"] && this.user$["jogkor"].includes("tanulo")) this.loginmode = "tanulo"

        if (this.loginmode == "dolgozo") url = '/api/user/'
        if (this.loginmode == "gondviselo") url = '/api/user-gondviselo/'
        if (this.loginmode == "tanulo") url = '/api/user-tanulo/'

        await this.data.setStorage("loginmode", this.loginmode)

        const headers = new HttpHeaders().set(
          'Authorization',
          `Bearer `
        );
        this.http
          .get(
            url + this.user$.username,
            {
              //headers: headers,
            }
          )
          .subscribe({
            next: async (response: any) => {

              // Védelem: a belépő user lehet, hogy CSAK a local_user (jelszó) táblában van, de NINCS
              // az allomany táblában (pl. a STANDALONE_BOOTSTRAP_USER nem létező dolgozó). Ekkor a
              // /api/user üres tömböt ad → a régi JSON.parse elszállt és a 'landing' örökre
              // "Egy pillanat..."-on ragadt. Most értelmes hibát mutatunk és visszaengedünk a login-ra.
              // A HIBÁT ne keverjük össze a NEM TALÁLTAM-mal. Ha a backend hibaobjektumot adott
              // (pl. hiányzó oszlop, leállt adatbázis), a felhasználó LÉTEZHET - ilyenkor nem
              // szabad azt állítani, hogy nincs jogosultsága, és a tokenjét sem szabad eldobni.
              const szerverHiba = response && !Array.isArray(response) && (response.error || response.err);
              if (szerverHiba) {
                console.error('A /user végpont hibát adott:', this.user$?.username, response);
                try {
                  window.alert('A belépés most nem tud befejeződni, mert a kiszolgáló hibát adott.\n\n' +
                    'Ez nem a te jogosultságoddal van összefüggésben - próbáld meg újra, és ha marad, jelezd a rendszergazdának:\n' +
                    (szerverHiba.sqlMessage || szerverHiba.message || JSON.stringify(szerverHiba)).slice(0, 300));
                } catch (e) { /* ignore */ }
                this.router.navigateByUrl('/login');
                return;
              }
              if (!Array.isArray(response) || !response[0] || !response[0].intezmenyadatok) {
                /*  MINDKÉT SAJÁT-ADAT VÉGPONTOT VÉGIGPRÓBÁLJUK, MINDEN NÉVALAKKAL.
                 *
                 *  A fenti első kérés CSAK a `username` claimmel ment el. Ha az IdP mást
                 *  küld annál, ami a táblában áll – Microsoft-federációnál tipikusan az
                 *  e-mail cím vagy az UPN –, akkor az a kérés üresen tér vissza.
                 *
                 *  KORÁBBAN a szülő itt PONTOSAN EGY próbát kapott: aki `gondviselo`
                 *  módban jött be, arra a lenti ág nem is futott le (`!== 'gondviselo'`),
                 *  tehát a többi névalakot soha nem próbáltuk ki. Aki nem a `username`
                 *  claimjével szerepelt a szülő-táblában, egyszerűen nem tudott belépni.
                 *
                 *  Mostantól mindkét végpontot végigjárjuk, mindegyiket az ÖSSZES
                 *  névalakkal – az aktuális móddal kezdve, mert az a legvalószínűbb.
                 *
                 *  A DOLGOZÓI végpont SZÁNDÉKOSAN marad ki. Ott az azonosítás az
                 *  `allomany.adid`, és a névalakok végigpróbálása nem hibatűrés volna,
                 *  hanem azonosítás-változtatás: egy e-mail cím alapján más dolgozó
                 *  sorára is ráfuthatnánk. A saját adat (gyermek, jegy, hiányzás) ennél
                 *  szűkebb kör, ott a többféle névalak elfogadása arányos. */
                const SAJAT_MODOK: Array<'gondviselo' | 'tanulo'> = ['gondviselo', 'tanulo'];
                const sorrend = SAJAT_MODOK.includes(this.loginmode as any)
                  ? [this.loginmode as 'gondviselo' | 'tanulo',
                     ...SAJAT_MODOK.filter((m) => m !== this.loginmode)]
                  : SAJAT_MODOK;
                for (const mod of sorrend) {
                  const valasz = await this.elsoTalalat(`/api/user-${mod}/`);
                  if (!valasz) continue;
                  this.loginmode = mod;
                  await this.data.setStorage('loginmode', mod);
                  response = valasz;
                  break;
                }
              }
              /*  DOLGOZÓI VÉGPONT UTOLSÓ ESÉLYKÉNT, A PONTOS NÉVVEL.
               *
               *  A belépési mód a token `jogkor` állításából dől el – ha az HIÁNYZIK, a
               *  felület gondviselőnek veszi a belépőt, és a dolgozói végpontot SOHA nem
               *  kérdezi meg. Egy jogkör nélküli fiókkal belépő kolléga emiatt akkor is
               *  „nincs intézményed" üzenetet kapott, ha az állományban tökéletesen ott
               *  volt. A pontos névvel megkérdezni viszont biztonságos: névalakokat itt
               *  NEM próbálunk (az az azonosítás megváltoztatása volna). */
              if (!Array.isArray(response) || !response[0] || !response[0].intezmenyadatok) {
                if (this.loginmode !== 'dolgozo' && this.user$?.username) {
                  try {
                    const dolgozoi: any = await firstValueFrom(
                      this.http.get('/api/user/' + encodeURIComponent(this.user$.username)));
                    if (Array.isArray(dolgozoi) && dolgozoi[0]?.intezmenyadatok) {
                      this.loginmode = 'dolgozo';
                      await this.data.setStorage('loginmode', 'dolgozo');
                      response = dolgozoi;
                    }
                  } catch (e) { /* marad a bekötés */ }
                }
              }

              /*  MAGÁTÓL RENDBE TESSZÜK, AHELYETT HOGY HIBÁT ÍRNÁNK KI.
               *
               *  Idáig akkor jutunk, ha a belépés sikerült, de a nyilvántartásban a
               *  belépési néven nincs senki. A felhasználó ezen nem tud segíteni – nem is
               *  érti, mi csúszott el –, ezért megkérjük a kiszolgálót, hogy oldja fel,
               *  ki ő. Ha sikerül, onnantól a NYILVÁNTARTÁSBELI azonosítóval dolgozunk. */
              if (!Array.isArray(response) || !response[0] || !response[0].intezmenyadatok) {
                const bekotott = await this.belepestBekot();
                if (bekotott) response = bekotott;
              }

              if (!Array.isArray(response) || !response[0] || !response[0].intezmenyadatok) {
                console.error('A belépő felhasználóhoz nincs intézmény/jogosultság az adatbázisban:', this.user$?.username, response);
                try {
                  /*  A HIBAÜZENET MONDJA MEG, HOL KERESTÜNK. A régi szöveg egyetlen
                   *  telepítés (CAESAR) szabályát írta le, ami az iskolai telepítéseken
                   *  félrevezető volt: azt sugallta, hogy a dolgozói táblában a helye,
                   *  miközben a belépő lehet szülő vagy tanuló is. Így viszont a
                   *  rendszergazda egyetlen pillantásból tudja, melyik táblában melyik
                   *  mezőt kell megnéznie – és azt is, hogy nem egy elgépelt névalakon
                   *  múlt, mert mindegyiket végigpróbáltuk. */
                  /*  AMI MARAD, AZT EMBERI NYELVEN MONDJUK MEG.
                   *
                   *  Idáig csak az jut el, akit a kiszolgáló sem tudott feloldani – vagyis
                   *  tényleg nincs a nyilvántartásban, vagy több emberre is illene. Ezen a
                   *  felhasználó nem tud segíteni, ezért nem táblaneveket sorolunk fel neki,
                   *  hanem megmondjuk, kihez forduljon. A részletek a naplóba mennek, és az
                   *  iskola a Belépések képernyőn tételesen is látja. */
                  window.alert('A belépésed sikerült, de a nyilvántartásban még nem találunk téged.\n\n'
                    + 'Ez nem a te hibád: a belépési fiókodat még össze kell kötni az iskolai '
                    + 'adataiddal. Kérjük, jelezd az iskolának — ők egy lépésben rendbe tudják tenni.\n\n'
                    + 'Azonosító: ' + (this.user$?.username || ''));
                } catch (e) { /* ignore */ }
                try { this.auth.clearLocalToken(); } catch (e) { /* ignore */ }
                this.router.navigateByUrl('/login');
                return;
              }

              let ia = JSON.parse(response[0].intezmenyadatok)
              if (response[0].jogkor) response[0].jogkor = this.parseJogkor(response[0].jogkor)
              if (response[0].elo) response[0].viselt_elo = response[0].elo
              if (response[0].ker) response[0].viselt_ker = response[0].ker
              if (response[0].vez) response[0].viselt_vez = response[0].vez
              if (response[0].gyermekek) response[0].gyermekek = JSON.parse(response[0].gyermekek)
              await this.data.setStorage("userMetadata", response[0])
              // Alapértelmezett feladatellátás kiválasztása – VÉDŐHÁLÓVAL. A /user query sorrendje szerint
              // az első nem-külső feladatellátás a helyes alapértelmezett (user-választás > intézményi > főállás).
              // DE ha nincs nem-külső, ESSÜNK VISSZA az első elérhetőre – különben a `[0]` undefined lenne, és a
              // user a „csak kijelentkezés" állapotban ragadna (sajatIntezmeny undefined → fejléc/menü/választó rejtve).
              {
                const iaAll = (JSON.parse(response[0].intezmenyadatok) || []).filter(Boolean);
                const belso = iaAll.filter(d => d && d.kulso == 0);
                const fm = this.fixedMode;
                if (fm) {
                  // Fixált alrendszer (több-app matrix): CSAK a fixedMode-ot támogató feladatellátás jöhet szóba.
                  const tamogatja = (d) => { try { const m = typeof d?.mode === 'string' ? JSON.parse(d.mode) : d?.mode; return Array.isArray(m) && m.includes(fm); } catch { return false; } };
                  response[0].intezmenyadatok = belso.find(tamogatja) || iaAll.find(tamogatja) || null;
                  this.nincsFixModeIntezmeny = !response[0].intezmenyadatok;
                } else {
                  response[0].intezmenyadatok = belso[0] || iaAll[0] || null;
                }
              }
              if (!response[0].intezmenyadatok) {
                if (this.fixedMode) {
                  // Ebben az appban (fixedMode) a usernek NINCS ilyen alrendszerű intézménye – a template jelzi.
                  console.warn('[fixedMode] nincs', this.fixedMode, 'alrendszerű intézmény ehhez a userhez');
                  return;
                }
                // Nincs egyetlen használható feladatellátás sem – ne ragadjunk némán (és ne reload-loopban).
                console.error('Nincs használható feladatellátás a felhasználóhoz:', this.user$?.username);
                try { window.alert('Ehhez a felhasználóhoz nincs használható intézmény/feladatellátás rendelve az adatbázisban. Fordulj az adminisztrátorhoz.'); } catch (e) { }
                await this.data.setStorage("userMetadata", null);
                return;
              }
              if (response[0].intezmenyadatok.jogkor) response[0].intezmenyadatok.jogkor = this.parseJogkor(response[0].intezmenyadatok.jogkor)
              if (response[0].intezmenyadatok.mode) response[0].intezmenyadatok.mode = JSON.parse(response[0].intezmenyadatok.mode)
              if (response[0].intezmenyadatok.color) response[0].intezmenyadatok.color = JSON.parse(response[0].intezmenyadatok.color)
              if (response[0].intezmenyadatok.color_secondary) response[0].intezmenyadatok.color_secondary = JSON.parse(response[0].intezmenyadatok.color_secondary)
              if (response[0].intezmenyadatok.color_shade) response[0].intezmenyadatok.color_shade = JSON.parse(response[0].intezmenyadatok.color_shade)
              if (response[0].jogkor) response[0].intezmenyadatok.jogkor = response[0].jogkor
              // Fixált alrendszernél a currentMode MINDIG a fixedMode (nem a feladatellátás mainmode-ja).
              const _cm = this.fixedMode || response[0].intezmenyadatok.mainmode;
              await this.data.setStorage("sajatIntezmeny", response[0].intezmenyadatok)
              await this.data.setStorage("currentMode", _cm)
              this.modes = valaszthatoModok((Array.isArray(response[0].intezmenyadatok.mode) ? response[0].intezmenyadatok.mode : []).map(d => d = { "name": d, "cim": modeNev(d) }))
              this.currentMode = _cm

              //console.log(response[0])

              this.http
                .get(
                  '/api/jogkor/' + this.currentMode + '/' + response[0].intezmenyadatok.intezmenyId,
                  {
                    //headers: headers,
                  }
                )
                .subscribe({
                  next: async (response2) => {
                    await this.data.setStorage("jogkor", response2)

                    response[0].intezmenyadatok = ia
                    response[0].department = await this.data.getJogkor()
                    await this.data.setStorage("userMetadata", response[0])
                    this.userMetadata = response[0]

                    this.http
                      .get(
                        '/api/access/' + this.currentMode + '/' + (await this.data.getJogkor()) + '/' + response[0].intezmenyadatok.filter(d => d.kulso == 0)[0].intezmenyId,
                        {
                          //headers: headers,
                        }
                      )
                      .subscribe({
                        next: async (response3: any) => {


                          await this.data.setStorage("access", JSON.parse(response3.url))
                          console.log(JSON.parse(response3.url))

                          this.http
                            .get(
                              '/api/menu/' + this.currentMode + '/' + (await this.data.getJogkor()) + '/' + response[0].intezmenyadatok.filter(d => d.kulso == 0)[0].intezmenyId,
                              {
                                //headers: headers,
                              }
                            )
                            .subscribe({
                              next: async (response4: any) => {

                                await this.data.setStorage("menu", response4)
                                //await this.data.setStorage("diskspace", response5)
                                this.setMenu(response[0]);

                                try { await this.masodikkor(); } catch (e) { console.error('[belépés] masodikkor:', e); }
                                //  A volt tanuló kezdőlapja a Dokumentumaim (korlátozott mód, lásd a menünél).
                                const voltTanulo = this.loginmode === 'tanulo' && Number(response[0]?.volt_tanulo) === 1;
                                const kezdo = voltTanulo
                                  ? '/dokumentumaim'
                                  : kezdoUrl((await this.data.getFromStorage('sajatIntezmeny'))?.kezdourl, this.currentMode);

                                /*  ÚJRABELÉPÉS UTÁN EGY TISZTA BETÖLTÉS. A lejárt munkamenet után a
                                 *  belépés a régi (mély) oldalra tér vissza, és az még a félkész
                                 *  tárolóval indult el: a menü, a tanév, az intézmény és a jogkör-
                                 *  kapcsolók hiányosak maradtak F5-ig (user, 2026-10-02). Most, hogy
                                 *  minden a tárolóban van, egyszer újratöltünk – a jelző miatt csak
                                 *  egyszer: a következő betöltés már a kész tárolóból indul. */
                                let ujratoltve = false;
                                try { ujratoltve = sessionStorage.getItem('ny_boot_reload') === '1'; } catch { /* ignore */ }
                                if (!ujratoltve && !(window as any).Capacitor?.isNativePlatform?.()) {
                                  try { sessionStorage.setItem('ny_boot_reload', '1'); } catch { /* ignore */ }
                                  window.location.replace(kezdo);
                                  return;
                                }
                                // A FITNESS-ÁG KIKERÜLT: `/fitness/ma` már nem létező útvonal
                                // ebben az alkalmazásban, a különvált program a saját
                                // szerverén nyílik. Ide hagyva egy FITNESS-módú belépő
                                // üres képernyőre futott volna.
                                this.router.navigateByUrl(kezdo)

                                /*this.http
                                  .get(
                                    '/api/diskspace',
                                    {
                                      //headers: headers,
                                    }
                                  )
                                  .subscribe({
                                    next: async (response5: any) => {
  
                                      await this.data.setStorage("menu", response4)
                                      await this.data.setStorage("diskspace", response5)
                                      this.setMenu(response[0]);
  
                                      //window.location.reload()
                                    }
                                  });*/
                              }
                            });
                        }
                      });
                  }
                });
            },
            error: (error) => {
              console.error('Error fetching data:', error);

            },
          });

        await this.data.setStorage("user", this.user$)

      } else {
        //  Kész tárolóval indultunk: a következő újrabelépés megint újratölthet egyszer.
        try { sessionStorage.removeItem('ny_boot_reload'); } catch { /* ignore */ }
        this.masodikkor();
      }


      // Check Auth0 session
      /*this.auth.isAuthenticated$.subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          this.auth.idTokenClaims$.subscribe((claims) => {
            // If there are ID token claims, store the ID token
            this.storage.set('id_token', claims.__raw);
          });
        }
      });
  
      App.addListener('appUrlOpen', ({ url }) => {
        // Must run inside an NgZone for Angular to pick up the changes
        // https://capacitorjs.com/docs/guides/angular
        this.ngZone.run(() => {
          if (url?.startsWith(callbackUri)) {
            if (
              url.includes('state=') &&
              (url.includes('error=') || url.includes('code='))
            ) {
              this.auth
                .handleRedirectCallback(url)
                .pipe(mergeMap(() => Browser.close()))
                .subscribe();
            } else {
              Browser.close();
            }
          }
        });
      });*/

    });
  }
  ngAfterViewInit() {
    setTimeout(() => this.cdr.detectChanges(), 0); // force render update
  }
  async masodikkor() {
    if (this.isLoggedIn) {
      this.userMetadata = await this.data.getFromStorage("userMetadata")


      //console.log(this.userMetadata)
      // Standalone-ban NINCS OIDC identitás – a loadCurrentIdentity() null-t adna és kiütné a user$-t
      // (emiatt a fejléc/menü `*ngIf="user$ && ..."` eltűnt). Ilyenkor a helyi user-t tartjuk meg.
      if (this.auth.isStandalone()) {
        const uname = this.auth.isStandaloneLogin() ? this.auth.localUsername() : this.auth.standaloneUser;
        this.user$ = { username: uname, preferred_username: uname };
      } else {
        this.user$ = await this.loadCurrentIdentity();
      }
      this.sajatIntezmeny = await this.data.getFromStorage("sajatIntezmeny")
      this.currentMode = await this.data.getFromStorage("currentMode")
      // Fixált alrendszer (több-app matrix): a currentMode MINDIG a fixedMode, akárhogy is volt tárolva.
      if (this.fixedMode && this.currentMode !== this.fixedMode) {
        this.currentMode = this.fixedMode;
        await this.data.setStorage("currentMode", this.fixedMode);
      }
      // Önjavítás: aki korábban a FITNESS-re (vagy annak DEVCENTER / KLINIKUS nézetére)
      // váltott, annak az maradt eltárolva. Mind a három a különvált programhoz tartozik,
      // amit ez az alkalmazás már nem szolgál ki – a tárolt érték tehát ragadós, ÜRES menüt
      // adna, útvonalak nélkül. Visszaállunk az intézmény fő alrendszerére.
      //
      // A tartalék NEM lehet 'FITNESS' (az volt itt korábban): egy nem létező alrendszerre
      // esni vissza pontosan azt a beragadást okozná, amit ez az ág megszüntet.
      if (NEM_ONALLO_MODOK.has(String(this.currentMode || '').toUpperCase())) {
        this.currentMode = this.sajatIntezmeny?.mainmode || 'SULINFORM';
        await this.data.setStorage("currentMode", this.currentMode);
      }
      // RECOVERY: ha a userMetadata megvan a cache-ben, de a sajatIntezmeny hiányzik (a korábbi bug
      // maradványa: a bootstrap elmentette a userMetadata-t, majd elhasalt a sajatIntezmeny beállítása előtt),
      // akkor csak a kijelentkezés gomb látszana. Ürítjük a userMetadata-t és újratöltünk → a (javított)
      // teljes bootstrap fut le, ami a védőhálóval helyesen beállítja a sajatIntezmeny-t (nincs reload-loop,
      // mert a bootstrap „nincs feladatellátás" ága szintén nullázza a userMetadata-t).
      if (this.isLoggedIn && !this.sajatIntezmeny) {
        console.warn('[bootstrap] hiányzó sajatIntezmeny a cache-ben → userMetadata ürítés + újratöltés');
        await this.data.setStorage("userMetadata", null);
        try { window.location.reload(); } catch (e) { /* ignore */ }
        return;
      }
      // Önjavítás: ha a tárolt sajatIntezmeny mezői nyers stringek (pl. régi/nem parse-olt váltás
      // maradéka), most parse-oljuk – így a lenti .mode.map soha nem fut STRING-en.
      if (this.sajatIntezmeny && !Array.isArray(this.sajatIntezmeny.mode)) {
        this.parseIntezmenyFields(this.sajatIntezmeny);
        await this.data.setStorage("sajatIntezmeny", this.sajatIntezmeny);
      }
      if (Array.isArray(this.sajatIntezmeny?.mode)
        && this.sajatIntezmeny.mode.includes("HOUSEHOLD")
        && !this.sajatIntezmeny.mode.includes("WEBSHOP")) {
        this.sajatIntezmeny.mode = [...this.sajatIntezmeny.mode, "WEBSHOP"];
        await this.data.setStorage("sajatIntezmeny", this.sajatIntezmeny);
      }
      this.modes = valaszthatoModok((Array.isArray(this.sajatIntezmeny?.mode) ? this.sajatIntezmeny.mode : [])
        .map(d => d = { "name": d, "cim": modeNev(d) }))

      //if (this.currentMode == "SULINFORM" && !this.tanevadatok) window.location.reload()

      // Az intézményhez felvett szín az elsődleges, de ha egy alrendszerhez nincs bejegyzés a
      // feladatellatas.color JSON-ben, akkor NEM hagyjuk üresen: az „undefined” érték érvénytelen
      // CSS-változót csinál, amitől minden color="primary" elem (a bal menü gombjai is!) fehér
      // alapon fehér betűvel jelenik meg. Ilyenkor az alrendszer márkaszínével dolgozunk.
      const modeSzin = modeSzinek(this.currentMode);
      const intezmenySzin = (forras: any) =>
        (forras && typeof forras === 'object' ? String(forras[this.currentMode] || '') : '') || '';
      document.documentElement.style.setProperty("--ion-color-primary", intezmenySzin(this.sajatIntezmeny.color) || modeSzin.primary);
      document.documentElement.style.setProperty("--ion-color-secondary", intezmenySzin(this.sajatIntezmeny.color_secondary) || modeSzin.secondary);
      document.documentElement.style.setProperty("--ion-color-primary-shade", intezmenySzin(this.sajatIntezmeny.color_shade) || modeSzin.shade);

      //console.log(this.sajatIntezmeny)
      if (this.currentMode == "SULINFORM" && !this.tanevadatok)
        this.http
          .get(
            '/api/nyilvantartas/tanev/' + (await this.data.getFromStorage("sajatIntezmeny")).intezmenyId,
            {
              //headers: headers,
            }
          )
          .subscribe({
            next: async (response11: any) => {

              await this.data.setStorage("tanev", JSON.stringify(response11))
              this.tanev = response11
              this.http
                .get(
                  '/api/nyilvantartas/tanevek/' + (await this.data.getFromStorage("sajatIntezmeny")).intezmenyId,
                  {
                    //headers: headers,
                  }
                )
                .subscribe({
                  next: async (response12: any) => {

                    await this.data.setStorage("tanevadatok", JSON.stringify(response12))
                    this.tanevadatok = response12
                    // A választó a munkatanévet mutassa (alapból az aktuális tanév).
                    this.valasztottTanev = await this.data.getMunkatanev()

                  }
                });

            }
          });

      if (this.currentMode == "BILLIARD") {
        await this.syncBilliardKivceg(this.router.url)
       }


      if (this.sajatIntezmeny.auth0 == 1 && this.userMetadata.auth0id == null) {
        this.migracio = true
        console.log("asd")
        this.http
          .get(
            '/assets/auth0.json',
            {
              //headers: headers,
            }
          )
          .subscribe({
            next: (response) => {
              this.auth0Users = response
            },
            error: (error) => {
              console.error('Error fetching data:', error);

            },
          });
      }
      this.refreshMenuFromApi();
      this.ref.detectChanges()
      //console.log(this.userMetadata)

    }
  }

  protected readonly environment = environment;
}
